!function(e){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{("undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this).EventEmitter3=e()}}(function(){return function i(s,f,c){function u(t,e){if(!f[t]){if(!s[t]){var n="function"==typeof require&&require;if(!e&&n)return n(t,!0);if(a)return a(t,!0);var r=new Error("Cannot find module '"+t+"'");throw r.code="MODULE_NOT_FOUND",r}var o=f[t]={exports:{}};s[t][0].call(o.exports,function(e){return u(s[t][1][e]||e)},o,o.exports,i,s,f,c)}return f[t].exports}for(var a="function"==typeof require&&require,e=0;e<c.length;e++)u(c[e]);return u}({1:[function(e,t,n){"use strict";var r=Object.prototype.hasOwnProperty,v="~";function o(){}function f(e,t,n){this.fn=e,this.context=t,this.once=n||!1}function i(e,t,n,r,o){if("function"!=typeof n)throw new TypeError("The listener must be a function");var i=new f(n,r||e,o),s=v?v+t:t;return e._events[s]?e._events[s].fn?e._events[s]=[e._events[s],i]:e._events[s].push(i):(e._events[s]=i,e._eventsCount++),e}function u(e,t){0==--e._eventsCount?e._events=new o:delete e._events[t]}function s(){this._events=new o,this._eventsCount=0}Object.create&&(o.prototype=Object.create(null),(new o).__proto__||(v=!1)),s.prototype.eventNames=function(){var e,t,n=[];if(0===this._eventsCount)return n;for(t in e=this._events)r.call(e,t)&&n.push(v?t.slice(1):t);return Object.getOwnPropertySymbols?n.concat(Object.getOwnPropertySymbols(e)):n},s.prototype.listeners=function(e){var t=v?v+e:e,n=this._events[t];if(!n)return[];if(n.fn)return[n.fn];for(var r=0,o=n.length,i=new Array(o);r<o;r++)i[r]=n[r].fn;return i},s.prototype.listenerCount=function(e){var t=v?v+e:e,n=this._events[t];return n?n.fn?1:n.length:0},s.prototype.emit=function(e,t,n,r,o,i){var s=v?v+e:e;if(!this._events[s])return!1;var f,c,u=this._events[s],a=arguments.length;if(u.fn){switch(u.once&&this.removeListener(e,u.fn,void 0,!0),a){case 1:return u.fn.call(u.context),!0;case 2:return u.fn.call(u.context,t),!0;case 3:return u.fn.call(u.context,t,n),!0;case 4:return u.fn.call(u.context,t,n,r),!0;case 5:return u.fn.call(u.context,t,n,r,o),!0;case 6:return u.fn.call(u.context,t,n,r,o,i),!0}for(c=1,f=new Array(a-1);c<a;c++)f[c-1]=arguments[c];u.fn.apply(u.context,f)}else{var l,p=u.length;for(c=0;c<p;c++)switch(u[c].once&&this.removeListener(e,u[c].fn,void 0,!0),a){case 1:u[c].fn.call(u[c].context);break;case 2:u[c].fn.call(u[c].context,t);break;case 3:u[c].fn.call(u[c].context,t,n);break;case 4:u[c].fn.call(u[c].context,t,n,r);break;default:if(!f)for(l=1,f=new Array(a-1);l<a;l++)f[l-1]=arguments[l];u[c].fn.apply(u[c].context,f)}}return!0},s.prototype.on=function(e,t,n){return i(this,e,t,n,!1)},s.prototype.once=function(e,t,n){return i(this,e,t,n,!0)},s.prototype.removeListener=function(e,t,n,r){var o=v?v+e:e;if(!this._events[o])return this;if(!t)return u(this,o),this;var i=this._events[o];if(i.fn)i.fn!==t||r&&!i.once||n&&i.context!==n||u(this,o);else{for(var s=0,f=[],c=i.length;s<c;s++)(i[s].fn!==t||r&&!i[s].once||n&&i[s].context!==n)&&f.push(i[s]);f.length?this._events[o]=1===f.length?f[0]:f:u(this,o)}return this},s.prototype.removeAllListeners=function(e){var t;return e?(t=v?v+e:e,this._events[t]&&u(this,t)):(this._events=new o,this._eventsCount=0),this},s.prototype.off=s.prototype.removeListener,s.prototype.addListener=s.prototype.on,s.prefixed=v,s.EventEmitter=s,void 0!==t&&(t.exports=s)},{}]},{},[1])(1)});

window.theme = window.theme || {};
window.themeInfo = {name: "RYNOR"};

var Events = new EventEmitter3();
Events.trigger = Events.emit; // trigger alias

/*============================================================================
 Underground Functions
==============================================================================*/
window.WAU = window.WAU || {};

WAU.Slideout = (function () {

	/*
	 * Elements
	 */
	var wrapper = undefined;

	/*
	 * RYNOR – keep the page exactly where the shopper is while a drawer is open
	 * (cart, filters, store availability). Phones and computers.
	 *
	 * Before: the page was frozen with body { position: fixed; top: -Y }, but body had
	 * already been given overflow: hidden by the "slideout-...--open" class. html/body are
	 * height: 100% and html has overflow-x: clip (layout/theme.liquid), so that cut the
	 * page down to one screen, the browser snapped to the top, Y was then read as 0 and
	 * the shopper was left at the top of the page, even after closing the cart.
	 *
	 * Now nothing on the page moves:
	 *  1. The scroll position is saved before anything changes.
	 *  2. Scrolling is switched off on <html> (class "rynor-scroll-lock", styled in
	 *     component-slideouts.css), so the page and the sticky header stay put behind
	 *     the dark overlay.
	 *  3. Touch screens: a finger drag can only scroll things inside the drawer (or another
	 *     pop-up), never the page behind it. This also covers older iPhones, which ignore
	 *     overflow: hidden on the page.
	 *  4. When the drawer closes the lock comes off. If anything nudged the page while the
	 *     drawer was open, it's put straight back where the shopper was (no animation).
	 */
	var SCROLL_LOCK_CLASS = 'rynor-scroll-lock';
	var pageLock = null;          // { x, y, drawers, padded, bodyPaddingRight } while locked
	var pageLockObserver = null;
	var lockTouchAllowed = null;  // decision for the finger currently on the screen

	function pageScrollX() {
		return window.pageXOffset || document.documentElement.scrollLeft || 0;
	}

	function pageScrollY() {
		return window.pageYOffset || document.documentElement.scrollTop || 0;
	}

	function jumpTo(x, y) {
		var root = document.documentElement;
		var previous = root.style.scrollBehavior;
		root.style.scrollBehavior = 'auto'; // put the page back instantly, never animated
		window.scrollTo(x, y);
		root.style.scrollBehavior = previous;
	}

	function focusWithoutScrolling(el) {
		if (!el || typeof el.focus !== 'function') return;
		try {
			el.focus({ preventScroll: true });
		} catch (e) {
			el.focus();
		}
	}

	function canScrollOnItsOwn(el) {
		var taller = el.scrollHeight > el.clientHeight + 1;
		var wider = el.scrollWidth > el.clientWidth + 1;
		if (!taller && !wider) return false;
		var style = window.getComputedStyle(el);
		return (taller && /(auto|scroll|overlay)/.test(style.overflowY)) ||
			(wider && /(auto|scroll|overlay)/.test(style.overflowX));
	}

	// May this finger drag scroll something? Yes inside the open drawer (or another
	// pop-up) when the touched spot can actually scroll. Never the page behind it.
	function touchMayScroll(target) {
		var el = target && target.nodeType === 1 ? target : (target && target.parentElement);
		if (!el || !pageLock) return false;
		if (el.closest('input[type="range"]')) return true;

		var stopAt = null;
		for (var i = 0; i < pageLock.drawers.length; i++) {
			if (pageLock.drawers[i].contains(el)) {
				stopAt = pageLock.drawers[i];
				break;
			}
		}
		if (!stopAt) {
			var page = document.querySelector('.site-wrap');
			if (page && page.contains(el)) return false;
		}

		for (var node = el; node && node !== document.body && node !== document.documentElement; node = node.parentElement) {
			if (canScrollOnItsOwn(node)) return true;
			if (node === stopAt) break;
		}
		return false;
	}

	function onLockedTouchStart(event) {
		lockTouchAllowed = (event.touches && event.touches.length > 1) ? true : touchMayScroll(event.target);
	}

	function onLockedTouchMove(event) {
		if (!pageLock) return;
		if (event.touches && event.touches.length > 1) return; // pinch-to-zoom keeps working
		if (lockTouchAllowed === null) lockTouchAllowed = touchMayScroll(event.target);
		if (!lockTouchAllowed && event.cancelable) event.preventDefault();
	}

	function onLockedTouchEnd(event) {
		if (!event.touches || !event.touches.length) lockTouchAllowed = null;
	}

	function lockPage(drawerEl) {
		if (pageLock) {
			// A drawer opening over an open one: the page is already held in place.
			if (drawerEl && pageLock.drawers.indexOf(drawerEl) === -1) pageLock.drawers.push(drawerEl);
			return;
		}

		var root = document.documentElement;
		var body = document.body;

		// 1. Remember where the shopper is, before anything else changes.
		pageLock = {
			x: pageScrollX(),
			y: pageScrollY(),
			drawers: drawerEl ? [drawerEl] : [],
			padded: false,
			bodyPaddingRight: body.style.paddingRight
		};

		// 2. Switch scrolling off on <html>. If the scrollbar disappears and nothing keeps
		//    its space (scrollbar-gutter), pad the page so nothing shifts sideways.
		var scrollbarBefore = window.innerWidth - root.clientWidth;
		root.classList.add(SCROLL_LOCK_CLASS);
		var scrollbarGap = scrollbarBefore - (window.innerWidth - root.clientWidth);
		if (scrollbarGap > 0) {
			body.style.paddingRight = scrollbarGap + 'px';
			pageLock.padded = true;
		}

		// 3. Touch screens: block drags that would move the page behind the drawer.
		document.addEventListener('touchstart', onLockedTouchStart, { capture: true, passive: true });
		document.addEventListener('touchmove', onLockedTouchMove, { capture: true, passive: false });
		document.addEventListener('touchend', onLockedTouchEnd, { capture: true, passive: true });
		document.addEventListener('touchcancel', onLockedTouchEnd, { capture: true, passive: true });

		// Safety net: if other code takes the "open" class off without closing the drawer
		// through this file, release the page as well so it can never stay stuck.
		if (window.MutationObserver) {
			pageLockObserver = new MutationObserver(function () {
				if (!isOpen()) unlockPage();
			});
			pageLockObserver.observe(body, { attributes: true, attributeFilter: ['class'] });
		}
	}

	function unlockPage() {
		if (!pageLock) return;
		var saved = pageLock;
		pageLock = null;
		lockTouchAllowed = null;

		if (pageLockObserver) {
			pageLockObserver.disconnect();
			pageLockObserver = null;
		}
		document.removeEventListener('touchstart', onLockedTouchStart, true);
		document.removeEventListener('touchmove', onLockedTouchMove, true);
		document.removeEventListener('touchend', onLockedTouchEnd, true);
		document.removeEventListener('touchcancel', onLockedTouchEnd, true);

		document.documentElement.classList.remove(SCROLL_LOCK_CLASS);
		if (saved.padded) document.body.style.paddingRight = saved.bodyPaddingRight;

		// 4. The page shouldn't have moved, but if anything nudged it (an older iPhone, the
		//    on-screen keyboard, an app script), put it back exactly where the shopper was.
		if (Math.abs(pageScrollY() - saved.y) > 1 || Math.abs(pageScrollX() - saved.x) > 1) {
			jumpTo(saved.x, saved.y);
		}
	}

	/*
	 * @description - Makes sure that the ESC Key works to close the menus.
	 */
	document.addEventListener('keyup', function (event) {
		if (event.key === 'Escape') {
			event.preventDefault();
			closeActiveSlideout();
		}
	});

	document.addEventListener('click', function (event) {
		if (event.target === document.querySelector(".js-slideout-overlay")) {
			closeActiveSlideout();
		}
	});

	/*
	 * @description - Closes the currently active slide.
	 */
	function closeActiveSlideout() {
			// Find the open slideout.
			const activeSlideout = document.querySelector('.slideout--active');
			const activeSlideoutName = activeSlideout.getAttribute('data-wau-slideout');
			const opener = document.querySelector('.js-slideout-open[data-wau-slideout-target="' + activeSlideoutName + '"]');
			const direction = opener.getAttribute('data-slideout-direction');
      const accordionsClosed = activeSlideout.getAttribute('data-wau-accordions-closed');

      if ( accordionsClosed !== null ) {
        WAU.Accordion.hideAll(activeSlideoutName);
      }

			close(direction, opener);
	}

	/*
	 * @description - Checks if the slideout is currently open or not.
	 * @return Boolean
	 */
	function isOpen() {
		wrapper = document.querySelector(".js-slideout-toggle-wrapper");
		return wrapper.classList.contains("slideout-left--open") || wrapper.classList.contains("slideout-right--open");
	}

	/*
	 * @description - Open a specific slideout in a specific direction.
	 * @param direction:String - the drction to open the slideout in.
	 * @param targetSlideoutEl:Node - The slideout element that will be opened.
	 */
	function open(direction, targetSlideoutEl, opener) {
		wrapper = wrapper || document.querySelector('.js-slideout-toggle-wrapper');
		if (!wrapper || !targetSlideoutEl) return;

		// RYNOR: hold the page exactly where it is (see lockPage above), before anything changes.
		lockPage(targetSlideoutEl);

		wrapper.classList.add("slideout-" + direction + "--open");
		wrapper.classList.remove("slideout-" + direction + "--closed");

		if (opener) opener.setAttribute("aria-expanded", "true");

    let slideoutName = targetSlideoutEl.dataset.wauSlideout;

    Events.trigger('slideout:open:' + slideoutName);

    // Aria and Active classes
    targetSlideoutEl.setAttribute('aria-hidden', 'false');

    setTimeout(function(){
      targetSlideoutEl.classList.add('slideout--active');
      targetSlideoutEl.classList.remove('slideout--close');
    }, 350);

    // Trapfocus on slideout until closed
    trapFocus(targetSlideoutEl)
	}

	/*
	 * @description - Closes all slideouts. Puts a11y focus back on the original opener.
	 * @param opener:Node - the opener element.
	 */
	function close(direction, opener) {
		const activeOpenSlideouts = document.querySelectorAll('.slideout--active');
		const openers = document.querySelectorAll(".js-slideout-open");
		const closers = document.querySelectorAll(".js-slideout-close");


		// Remove content if quickview
		const openerControls = opener && opener.getAttribute("aria-controls");
		const isQuickviewOpener = opener && (
			openerControls === 'quickview' ||
			openerControls === 'slideout-quickview' ||
			openerControls === 'modal-quickview' ||
			opener.getAttribute('data-wau-slideout-target') === 'quickview' ||
			opener.getAttribute('data-wau-modal-target') === 'quickview'
		);
		if (isQuickviewOpener) {
			var qvContent = document.querySelector('.js-quickview-content'); if (qvContent) qvContent.innerHTML = '';
		}

		// Close the slideout.
		wrapper.classList.remove("slideout-" + direction + "--open");
		wrapper.classList.add("slideout-" + direction + "--closed");

		// Close all active drawers. This is incase there is more than 1 slide on a direction.
		activeOpenSlideouts.forEach(function (activeSlideoutDrawer) {
      const accordionsClosed = activeSlideoutDrawer.getAttribute('data-wau-accordions-closed');
      const activeSlideoutName = activeSlideoutDrawer.getAttribute('data-wau-slideout');

      if ( accordionsClosed !== null ) {
        WAU.Accordion.hideAll(activeSlideoutName);
      }

      Events.trigger('slideout:close:' + activeSlideoutName);

      // Aria and Active classes
      activeSlideoutDrawer.classList.remove('slideout--active');
      activeSlideoutDrawer.classList.add('slideout--close');

      setTimeout(function(){
        activeSlideoutDrawer.setAttribute('aria-hidden', 'true');
      }, 350);

      // Remove focus on button
      if (activeSlideoutDrawer.querySelector('.js-slideout-close')) activeSlideoutDrawer.querySelector('.js-slideout-close').blur();

		});

		// Makes sure aria-expanded false is added to all the open and close buttons.
		openers.forEach(function (opener) {
			opener.setAttribute('aria-expanded', 'false');
		});

		closers.forEach(function (closer) {
			closer.setAttribute('aria-expanded', 'false');
		});

    // RYNOR: release the page (see unlockPage above). It was held in place the whole
    // time, so the shopper is still exactly where they were before the drawer opened.
    if (!isOpen()) unlockPage();
	}

	/*
	 * @description - Closes a specific slideout given the name in data-wau-slideout attribute
	 * @return void
	 */
	function closeByName(name) {
		const closer = document.querySelector('[data-wau-slideout-target="' + name + '"]');
		const direction = closer.getAttribute('data-slideout-direction');
		const opener = document.querySelector('.js-slideout-open[data-wau-slideout-target="' + name + '"]');
		close(direction, opener);
	}

	/*
	 * @description - Opens a specific slideout given the name in data-wau-slideout attribute
	 * @return void
	 */
	function openByName(name) {
		const opener = document.querySelector('[data-wau-slideout-target="' + name + '"]')
		const direction = opener ? opener.getAttribute('data-slideout-direction') : 'left';
		const targetSlideoutEl = document.querySelector('[data-wau-slideout="' + name + '"]');
		open(direction, targetSlideoutEl, opener);
	}

	/*
	 * @description - Creates a new aside element to be used as a slideout.
	 * @param direction:String - the direction that the slideout will open in. "left" or "right"
	 * @param name:String - An explicit name to refer to the slideout by on a trigger.
	 * @param wrapperEl:Node - An element that can be explicitly passed in as the wrapper element.
	 */
  function createSlideoutEl(direction, name, wrapperEl) {

     const aside = document.createElement('aside');
     const innerDiv = document.createElement('div');
     const innerContentDiv = document.createElement('div');
     const opener = document.querySelector('[data-wau-slideout-target="' + name + '"]');
     const content = document.querySelector('[data-wau-slideout-content="' + name + '"]');
     const generatedId = "slideout-" + name;

 		wrapperEl = wrapperEl || wrapper;

    if ( content.hasAttribute('data-wau-accordions-closed') ) {
      aside.setAttribute('data-wau-accordions-closed', '');
    }

     // Create outer wrapper
     aside.classList.add('slideout');
     aside.classList.add('slideout__drawer-' + direction);
     aside.setAttribute('data-wau-slideout', name);
     aside.setAttribute('id', generatedId); // setting an id here so that we can set the aria-controls attribute on the opener.

     // Create inner wrapper and move content to it
     innerDiv.classList.add('slideout__inner-wrapper');
     innerDiv.classList.add('slideout__general-slide__wrapper');
     innerContentDiv.innerHTML = content.innerHTML;
     innerContentDiv.classList.add('slideout__inner-content-container');

 		// Empty content so no conflict
 		content.innerHTML = '';

     // Add close button to Inner
 		if ( content.dataset.wauSlideoutButton && content.dataset.wauSlideoutButton == 'true' ) {
 			let closeDiv = createCloser(name, direction);
 			innerDiv.prepend(closeDiv);
 		}

     // Add inner wrapper to outer wrapper
     aside.appendChild(innerDiv);
     innerDiv.appendChild(innerContentDiv);

 		opener.setAttribute('aria-controls', generatedId);
 		wrapperEl.appendChild(aside);

 		return aside;
 	}

	/*
	 * @description - Empties inner wrapper of slideout and replaces content with previous content
	 */
	function reloadSlideoutContents(name) {
		const content = document.querySelector('[data-wau-slideout-content="' + name + '"]');
		const drawer = document.querySelector('aside[data-wau-slideout="' + name + '"]');
		const innerWrapper = drawer.querySelector('.slideout__inner-content-container');

		innerWrapper.innerHTML = content.innerHTML;
	}

  /*
   * @description - Traps keyboard focus inside slideout when open
   */
  function trapFocus(activeSlideout) {
     // add all the elements inside modal which you want to make focusable
    const  focusableElements =
        'button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])';

    const firstFocusableElement = activeSlideout.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
    const focusableContent = activeSlideout.querySelectorAll(focusableElements);
    const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

    document.addEventListener('keydown', function(e) {
      let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) { // if shift key pressed for shift + tab combination
        if (document.activeElement === firstFocusableElement) {
          focusWithoutScrolling(lastFocusableElement); // add focus for the last focusable element
          e.preventDefault();
        }
      } else { // if tab key is pressed
        if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
          focusWithoutScrolling(firstFocusableElement); // add focus for the first focusable element
          e.preventDefault();
        }
      }
    });

    focusWithoutScrolling(firstFocusableElement);
  }
	/*
	 * @description - Initializes the plugin by adding all of the appropriate event listeners.
	 */
  function init(name) {
		if (typeof name === "undefined") {
			console.log("The Slideout must have an associated name.");
			return;
		}

		wrapper = document.querySelector('.js-slideout-toggle-wrapper');

		const slideoutOpeners = document.querySelectorAll('.js-slideout-open[data-wau-slideout-target="' + name + '"]');

		let slideoutTargetEl = undefined;

   slideoutOpeners.forEach((slideoutOpener, i) => {
     const slideoutDirection = slideoutOpener.getAttribute('data-slideout-direction');

     if (slideoutOpener) {
       slideoutTargetEl = document.querySelector(`aside[data-wau-slideout=${name}]`);
     }

     if (!slideoutTargetEl) {
       slideoutTargetEl = createSlideoutEl(slideoutDirection, name, wrapper);
     }

		 // Set tabindex so it skips hidden slideout

    // Set Aria Hidden on Load
    slideoutTargetEl.setAttribute('aria-hidden', 'true');

 		// Trigger event for outside functions to listen and use
 		 Events.trigger('slideout:active:' + name);
     slideoutOpener.addEventListener('click', function () {
       open(slideoutDirection, slideoutTargetEl, slideoutOpener);
     });

   });

   const slideoutClosers = document.querySelectorAll('.js-slideout-close');

		slideoutClosers.forEach((slideoutCloser, i) => {
			const slideoutCloseDirection = slideoutCloser.getAttribute('data-slideout-direction');
			slideoutCloser.addEventListener('click', function () {
				close(slideoutCloseDirection, slideoutCloser);
			});
		});
	}

	const privateFunctions = {
		openByName,
		closeByName,
		createSlideoutEl,
    reloadSlideoutContents
	};

	let returnObj = {};

	returnObj.init = init;

	/*
	 * @description - Gives WAU.Slideout external access to the internal functions for use in Shopify Events.
	 */
	Object.keys(privateFunctions).forEach(function (pf) {
		returnObj['_' + pf] = privateFunctions[pf];
	});

	return returnObj;

}());

WAU.Modal = (function() {
  /*
   * Elements
   */
  var wrapper = undefined;
  /*
   * @description - Makes sure that the ESC Key works to close the menus.
   */
  document.addEventListener('keyup', function(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeActiveModal();
    }
  });
  document.addEventListener('click', function(event) {
    if (event.target === document.querySelector(".js-modal-overlay")) {
      closeActiveModal();
    }
  });
  /*
   * @description - Closes the currently active modal.
   */
  function closeActiveModal() {
    // Find the open modal.
    const activeModal = document.querySelector('.modal--active');
    const activeModalName = activeModal.getAttribute('data-wau-modal');
    const closer = activeModal.querySelector('.js-modal-close');

    close(closer);
  }
  /*
   * @description - Checks if the modal is currently open or not.
   * @return Boolean
   */
  function isOpen() {
    wrapper = document.querySelector(".js-modal-toggle-wrapper");
    return wrapper.classList.contains("modal--open");
  }
  /*
   * @description - Open a specific modal.
   * @param targetSlideoutEl:Node - The modal element that will be opened.
   */
  function open(targetModalEl, opener) {

		// Fix body wrapper so no scrolling on mobile
    let scrollPosition = Math.abs(0 - document.querySelector('.site-wrap').getBoundingClientRect().top);
    wrapper.style.width = '100%';

		if ( targetModalEl.hasAttribute("data-wau-modal-full") ) {
			wrapper.style.overflowY = 'hidden';
		} else {
			// Stop from scrolling to top
			targetModalEl.style.top = `calc(${scrollPosition}px + 10vh)`;
		}

    wrapper.classList.add("modal--open");
    wrapper.classList.remove("modal--closed");
    targetModalEl.classList.add('modal--active');

    // Add specific modal type class
    if ( targetModalEl.getAttribute("data-wau-modal") ) {
      var elClass = targetModalEl.getAttribute("data-wau-modal"),
          elClass = "modal-" + elClass + "--open";
      wrapper.classList.add(elClass);
    }

    opener.setAttribute("aria-expanded", "true");
  }
  /*
   * @description - Closes all modals. Puts a11y focus back on the original opener.
   * @param opener:Node - the opener element.
   */
  function close(openerEl) {
    const activeOpenModals = document.querySelectorAll('.modal--active');
    const openers = document.querySelectorAll(".js-modal-open");
    const closers = document.querySelectorAll(".js-modal-close");

    // Remove content if quickview
    const openerControls = openerEl && openerEl.getAttribute("aria-controls");
    const isQuickviewOpener = openerEl && (
      openerControls === 'quickview' ||
      openerControls === 'slideout-quickview' ||
      openerControls === 'modal-quickview' ||
      openerEl.getAttribute('data-wau-slideout-target') === 'quickview' ||
      openerEl.getAttribute('data-wau-modal-target') === 'quickview'
    );
    if (isQuickviewOpener) {
      var qvContent = document.querySelector('.js-quickview-content'); if (qvContent) qvContent.innerHTML = '';
    }

    // Close the Modal.
    wrapper.classList.remove("modal--open");
    wrapper.classList.add("modal--closed");

    // Close all active modals. This is incase there is more than 1..
    activeOpenModals.forEach(function(activeModalDrawer) {
      // Remove specific modal type class
      if ( activeModalDrawer.getAttribute("data-wau-modal") ) {
        var elClass = activeModalDrawer.getAttribute("data-wau-modal"),
            elClass = "modal-" + elClass + "--open";
        wrapper.classList.remove(elClass);
      }

      activeModalDrawer.classList.remove('modal--active');

			// For full width modal
			if ( activeModalDrawer.hasAttribute("data-wau-modal-full") ) {
				wrapper.style.overflowY = 'unset';
			}

    });

    // Makes sure aria-expanded false is added to all the open and close buttons.
    openers.forEach(function(opener) {
      opener.setAttribute('aria-expanded', 'false');
    });
    closers.forEach(function(closer) {
      closer.setAttribute('aria-expanded', 'false');
    });

    // Fix body wrapper so no scrolling on mobile
    wrapper.style.removeProperty('overflow');
    wrapper.style.removeProperty('position');
    wrapper.style.removeProperty('padding-right');
    wrapper.style.removeProperty('top');
    wrapper.style.removeProperty('width');
  }
  /*
   * @description - Closes a specific modal given the name in data-wau-slideout attribute
   * @return void
   */
  function closeByName(name) {
    const closer = document.querySelector('[data-wau-modal-target="' + name + '"]');
    const opener = document.querySelector('.js-modal-open[data-wau-modal-target="' + name + '"]');
    close(opener);
  }
  /*
   * @description - Opens a specific modal given the name in data-wau-slideout attribute
   * @return void
   */
  function openByName(name) {
    const opener = document.querySelector('[data-wau-modal-target="' + name + '"]');
    const targetModalEl = document.querySelector('[data-wau-modal="' + name + '"]');
    open(targetModalEl, opener);
  }
  /*
   * @description - Creates a new close button inside created modal.
   * @param name:String - An explicit name to refer to the modal by on a trigger.
   */
  function createCloser(name) {
    const closeDiv = document.createElement('div');
    const button = document.createElement('button');
    const icon = document.createElement('div');
    closeDiv.classList.add('slideout__trigger--close');
    closeDiv.classList.add('slideout__trigger-' + name + '__wrapper');
    closeDiv.classList.add('slideout__trigger-general-modal__wrapper');
    button.classList.add('slideout__trigger-' + name);
    button.classList.add('slideout__trigger-general-modal');
    button.classList.add('js-modal-close');
    button.setAttribute('aria-controls', 'modal-' + name);
    button.setAttribute('aria-label', (window.RynorStrings && window.RynorStrings.close_modal) || 'Close modal');
    icon.classList.add('icn-close');
    button.appendChild(icon);
    closeDiv.appendChild(button);
    return closeDiv;
  }
  /*
   * @description - Creates a new div element to be used as a modal.
   * @param name:String - An explicit name to refer to the modal by on a trigger.
   * @param wrapperEl:Node - An element that can be explicitly passed in as the wrapper element.
   */
  function createModalEl(name, wrapperEl) {
    const div = document.createElement('div');
    const innerDiv = document.createElement('div');
    const innerContentDiv = document.createElement('div');
    const opener = document.querySelector('[data-wau-modal-target="' + name + '"]');
    const content = document.querySelector('[data-wau-modal-content="' + name + '"]');
    const generatedId = "modal-" + name;
    wrapperEl = wrapperEl || wrapper;

    // Create outer wrapper
    div.classList.add('modal');
    div.classList.add('modal__container');
		div.setAttribute('data-wau-modal', name);
		div.setAttribute('id', generatedId); // setting an id here so that we can set the aria-controls attribute on the opener.

		// Set full width
		if ( content && content.hasAttribute('data-wau-modal-full') ) {
			div.setAttribute('data-wau-modal-full', '');
		}

    // Create inner wrapper and move content to it
    innerDiv.classList.add('modal__inner-wrapper');
    innerDiv.classList.add('modal__general-modal__wrapper');
    innerContentDiv.innerHTML = content.innerHTML;
    innerContentDiv.classList.add('modal__inner-content-container');

    // Add close button to Inner
    let closeDiv = createCloser(name);
    innerDiv.prepend(closeDiv);

    // Add inner wrapper to outer wrapper
    div.appendChild(innerDiv);
    innerDiv.appendChild(innerContentDiv);
    opener.setAttribute('aria-controls', generatedId);
    wrapperEl.appendChild(div);
    return div;
  }
  /*
   * @description - Initializes the plugin by adding all of the appropriate event listeners.
   */
  function init(name) {
    if (typeof name === "undefined") {
      console.log("The Modal must have an associated name.");
      return;
    }
    wrapper = document.querySelector('.js-modal-toggle-wrapper');
    const modalOpeners = document.querySelectorAll('.js-modal-open[data-wau-modal-target="' + name + '"]');

    let modalTargetEl = undefined;
    if (modalOpeners) {
      modalTargetEl = document.querySelector(`div[data-wau-modal=${name}]`);
    }

    if (!modalTargetEl) {
      modalTargetEl = createModalEl(name, wrapper);
    }

    modalOpeners.forEach((modalOpener, i) => {
      modalOpener.addEventListener('click', function() {
        open(modalTargetEl, modalOpener);
      });
    });

    const modalClosers = document.querySelectorAll('.js-modal-close');
    modalClosers.forEach(function(modalCloser) {
      modalCloser.addEventListener('click', function() {
        close(modalCloser);
      });
    });
  }
  const privateFunctions = {
    openByName,
    closeByName,
    createModalEl
  };
  let returnObj = {};
  returnObj.init = init;
  /*
   * @description - Gives WAU.Slideout external access to the internal functions for use in Shopify Events.
   */
  Object.keys(privateFunctions).forEach(function(pf) {
    returnObj['_' + pf] = privateFunctions[pf];
  });
  return returnObj;
}());

WAU.Accordion = (function () {

  const classes = {
    show: "is-active",
    open: "js-accordion-is-open",
    mobileNavAccordion: "js-accordion-mobile-nav"
  };

  const selectors = {
    accordion: ".js-accordion",
    accordionItem: '.c-accordion__item',
    accordionLink: ".js-accordion-link",
    accordionHeader: ".js-accordion-header",
    accordionPanel: ".c-accordion__panel"
  };

  const publicAPIs = {};

  /*
   * @description strips class period
   */
  const stripClassPeriod = function(className) {
    if (!className) return;
    return className.split('.')[1];
  }

  /*
   * @description returns class naem
   */
  publicAPIs.getConfigClass = function (className) {
    if (!className) return;
    if (classes[className] && classes[className] != '') {
      return classes[className];
    } else {
      return false;
    }
  };

  /*
   * @description Hides an accordion item
   */
  publicAPIs.hide = function (target) {

    target.setAttribute("aria-expanded", "false");
		target.parentNode.classList.remove('accordion-expanded');

    const panel = document.querySelector(
      `#${target.getAttribute("aria-controls")}`
    );

    panel.setAttribute("hidden", "");

    // 350 matches the CSS transition timing
    setTimeout(function(){
      panel.style.display = "none";
    }, 350);
  };

  /*
   * @description Hides all accordion items at once
   */
  publicAPIs.hideAll = function (name) {
    const accordion = document.querySelector('[data-accordion-family="' + name + '"]');

    if ( !accordion ) return false;

    const accordionHeaders = document.querySelectorAll('[data-accordion-family="' + name + '"] > .js-accordion-header');

    accordionHeaders.forEach((item, i) => {
      const target = item.querySelector('[data-toggle="accordion"]');

      // Close each accordion item
      target.setAttribute("aria-expanded", "false");
  		target.parentNode.classList.remove('accordion-expanded');

      const panel = document.querySelector(
        `#${target.getAttribute("aria-controls")}`
      );

      panel.setAttribute("hidden", "");

      // 350 matches the CSS transition timing
      setTimeout(function(){
        panel.style.display = "none";
      }, 350);

    });

  };

  /*
   * @description Shows an accordion item
   */
  publicAPIs.show = function (target, allowMultiple) {

    const panel = document.querySelector(
      `#${target.getAttribute("aria-controls")}`
    );

    const parentElement = target.closest(panel.getAttribute("data-parent"));

    const allowMultipleFlag = allowMultiple || parentElement
      .hasAttribute("data-accordion-allow-multiple") ? true : false;

    const isMobileNav = parentElement.classList.contains(classes.mobileNavAccordion);

    if (!allowMultipleFlag && panel.hasAttribute("data-parent")) {

      let childSelector = '';

      if (isMobileNav) {
        childSelector = ':scope > li > [aria-expanded="true"]';
      } else {
        childSelector = ':scope > [aria-expanded="true"]';
      }

      if (!childSelector) {
        return;
      }

      const activePanels = target
        .closest(panel.getAttribute("data-parent"))
        .querySelectorAll(
        childSelector
      );

      if (!activePanels) {
        return;
      }

      activePanels.forEach(function (element) {
        publicAPIs.hide(element);
      });
    }

    target.setAttribute("aria-expanded", "true");
		target.parentNode.classList.add('accordion-expanded');

    panel.removeAttribute("hidden");

    panel.style.display = "block";

  };

  /*
   * @description Toggle showing and hiding an accordion item
   */
  publicAPIs.toggle = function (target, allowMultiple) {

    if (target.getAttribute("aria-expanded") == "true") {
      publicAPIs.hide(target);
      return;
    } else {
      publicAPIs.show(target, allowMultiple);
    }
  };

  /*
   * @description Initialize function
   */
  publicAPIs.init = function () {

    // Hide add accordion panels
    document.querySelectorAll(`[data-toggle="accordion"]:not(.${classes.open})`).forEach(function(element, index) {
      publicAPIs.hide(element);
    });

    // Add keyboard accessibility events
    document.addEventListener('keydown', function(event) {
      let target = event.target;
      const key = event.which.toString();
      const disablePageScroll = false;
      const pageScrollOptions = disablePageScroll ? {preventScroll: true} : {preventScroll: false};
      const isDropDownArrow = target.classList.contains('dropdown-arrow');

      if (target.classList.contains(stripClassPeriod(selectors.accordionHeader)) ||
          target.classList.contains(stripClassPeriod(selectors.accordionLink)) ||
          isDropDownArrow ) {

        if (key.match(/38|40/)) {

          const isMobile = target.closest(selectors.accordion).classList.contains(classes.mobileNavAccordion) ? true : false;

          const accordionSelector = isMobile ? `:scope > li > ${selectors.accordionLink}` : `:scope > ${selectors.accordionHeader}`;

          const accordions = target.closest(selectors.accordion).querySelectorAll(accordionSelector);

          if (isMobile && isDropDownArrow) {
            target.previousElementSibling.focus(pageScrollOptions);
            return;
          }

          let indexPlace;
          accordions.forEach(function(element, index) {
            if (element == target) {
              indexPlace = index;
            }
          });
          const direction = key.match(/34|40/) ? 1 : -1;
          const length = accordions.length;
          const newIndex = (indexPlace + length + direction) % length;

          accordions[newIndex].focus(pageScrollOptions);
        }
      }
    });

    document.addEventListener("click", function (event) {

      const target = event.target.matches('[data-toggle="accordion"]') ? event.target : event.target.closest('[data-toggle="accordion"]');

      if (!target) {
        return false;
      }

			event.preventDefault();

      publicAPIs.toggle(target);
    });

		document.addEventListener("click", function (event) {
			if ( event.target.classList.contains('js-accordion-link') ) {
				let url = event.target.getAttribute('href');
				if ( url == '' ) {
					event.preventDefault();

					let target = event.target.parentNode.querySelector('[data-toggle="accordion"]');
					publicAPIs.toggle(target);
				}
			}
		});
  };

  return publicAPIs;

})();

WAU.Helpers = (function() {
  var touchDevice = false;

  function setTouch() {
    touchDevice = true;
  }

  function isTouch() {
    return touchDevice;
  }

  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this,
        args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

	function makeSticky(amountToScroll, elementClass, elementHeight) {
    const clearElement = document.querySelector(".js-clear-element"),
          stickyElement = document.querySelector(elementClass);

		if ( clearElement.classList.contains('over-content--true') && window.matchMedia('(min-width: 968px)').matches ) {
      height = "0px";
		} else {
			height = elementHeight  + "px";
		}

    if (window.pageYOffset > amountToScroll) {
      stickyElement.classList.add('sticky--active');
      clearElement.style.height = height;
    } else {
      stickyElement.classList.remove('sticky--active');
      clearElement.style.height = "0px";
    }
  }

	function showHide(show, hide) {
	  var show = document.getElementById(show);
	  show.classList.remove("hide");
	  show.classList.add("show");
	  show.style.display = 'block';

	  var hide = document.getElementById(hide);
	  hide.classList.remove("show");
	  hide.classList.add("hide");
	  hide.style.display='none';
	}

  function Toggle(id) {
    var element = document.getElementById(id);
    if ( element.classList.contains('animate-hide') ) {
      element.classList.remove("animate-hide", "fadeOut");
      element.classList.add("animate-show", "fadeIn");
      element.style.visibility = "visible";
    } else {
	  element.classList.remove("animate-show", "fadeIn");
      element.classList.add("animate-hide", "fadeOut");
      element.style.visibility = "hidden";
    }
  }

  function toggleClass(id, className) {
    var element = document.getElementById(id);
    if (!element) return false;
    if ( element.classList.contains(className) ) {
      element.classList.remove(className);
    } else {
      element.classList.add(className);
    }
  }

  function Accordion(container, tlink, submenu) {

    let accorContent = container.querySelector(submenu);

    if ( !container.querySelector(tlink) ) return false;

    container.querySelector(tlink).addEventListener('click', function(event) {
      event.preventDefault();

      // Toggle class on label and update a11y
      if ( this.classList.contains('closed') ) {
        this.classList.remove('closed');
        this.parentElement.classList.remove('closed');
        this.setAttribute('aria-expanded', 'true');
      } else {
        this.classList.add('closed');
        this.parentElement.classList.add('closed');
        this.setAttribute('aria-expanded', 'false');
      }

      // Show content
      if ( accorContent.classList.contains('closed') ) {
        accorContent.classList.remove("closed");
        accorContent.style.display = "block";
      } else {
        accorContent.classList.add("closed");
        accorContent.style.display = "none";
      }

    });
  }

	function fadeToggle(el, display) {
		var style = display || "block";

		if (el.style.display === 'none') {
			el.style.opacity = 0;
	    el.style.display = display || "block";

	    (function fade() {
	      var val = parseFloat(el.style.opacity);
	      if (!((val += 0.1) > 1)) {
	        el.style.opacity = val;
	        requestAnimationFrame(fade);
	      }
	    })();

		} else if (el.style.display === style) {
			el.style.opacity = 1;

	    (function fade() {
	      if ((el.style.opacity -= 0.1) < 0) {
	        el.style.display = "none";
	      } else {
	        requestAnimationFrame(fade);
	      }
	    })();
		}
	}

  function fadeOut(el){
    el.style.opacity = 1;

    (function fade() {
      if ((el.style.opacity -= 0.1) < 0) {
        el.style.display = "none";
      } else {
        requestAnimationFrame(fade);
      }
    })();
  }

  function fadeIn(el, display){
    el.style.opacity = 0;
    el.style.display = display || "block";

    (function fade() {
      var val = parseFloat(el.style.opacity);
      if (!((val += 0.1) > 1)) {
        el.style.opacity = val;
        requestAnimationFrame(fade);
      }
    })();
  }

  function getScrollbarWidth() {

    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;

  }

  function smoothScrollTo(endX, endY, duration) {
     let startX = window.scrollX || window.pageXOffset,
     startY = window.scrollY || window.pageYOffset,
     distanceX = endX - startX,
     distanceY = endY - startY,
     startTime = new Date().getTime();
     // Easing function
     let easeInOutQuart = function(time, from, distance, duration) {
         if ((time /= duration / 2) < 1) return distance / 2 * time * time * time * time + from;
         return -distance / 2 * ((time -= 2) * time * time * time - 2) + from;
     };
     let timer = window.setInterval(function() {
         let time = new Date().getTime() - startTime,
         newX = easeInOutQuart(time, startX, distanceX, duration),
         newY = easeInOutQuart(time, startY, distanceY, duration);
         if (time >= duration) {
             window.clearInterval(timer);
         }
         window.scrollTo(newX, newY);
     }, 1000 / 60); // 60 fps
  }

	function wrapIframe(options) {
		options.iframes.forEach(function(iframe) {
			var wrapper = document.createElement('div');
			wrapper.classList.add(options.iframeWrapperClass);

			iframe.parentNode.insertBefore(wrapper, iframe);
			wrapper.appendChild(iframe);

			iframe.src = iframe.src;
		});
	}

	function wrapTable(options) {
	 options.tables.forEach(function(table) {
		 var wrapper = document.createElement('div');
		 wrapper.classList.add(options.tableWrapperClass);

		 table.parentNode.insertBefore(wrapper, table);
		 wrapper.appendChild(table);
	 });
	}

	function scriptLoader() {
		  /**
		   * Promise-based script loader
		   * @param {string} url
		   * @param {object=} attr
		   * @returns {Promise}
		   */
		  const loader = (url, attr) => new Promise((resolve, reject) => {
		    const script = window.document.createElement('script');
		    script.src = url;
		    script.async = true;
		    script.crossOrigin = 'anonymous';

		    attr = attr || {};

		    for (const attrName in attr) {
		      script[attrName] = attr[attrName];
		    }

		    script.addEventListener('load', () => {
		      resolve(script);
		    }, false);

		    script.addEventListener('error', () => {
		      reject(script);
		    }, false);

				function scriptExists(url) {
				  return document.querySelectorAll(`script[src="${url}"]`).length > 0;
				}

				if ( !scriptExists(url) ) {
					window.document.head.appendChild(script);
				} else {
					resolve(script);
				}

		  });

		  /**
		   * Loads scripts asynchronously
		   * @param {string|string[]} urls
		   * @param {object=} attr Other script tag attributes
		   * @returns {Promise}
		   */
		  this.load = (urls, attr) => {
		    if (!Array.isArray(urls)) {
		      urls = [urls];
		    }

		    return Promise.all(urls.map(url => loader(url, attr)));
		  }

		  /**
		   * Loads scripts asynchronously. It supports multiple url arguments, so each one will be loaded right after the
		   * previous is loaded. This is a way of chaining dependency loading.
		   *
		   * @param {string|string[]} urls, ...
		   * @returns {Promise}
		   */
		  this.loadChain = function (urls) {
		    const args = Array.isArray(arguments) ? arguments : Array.prototype.slice.call(arguments);
		    const p = this.require(args.shift());
		    const self = this;
		    return args.length ? p.then(() => {
		      self.requireChain(...args);
		    }) : p;
		  }
	}

	function scriptExists(url) {
		return document.querySelectorAll(`script[src="${url}"]`).length > 0;
	}

	function isElementPastEdge(element) {
		const bounding = element.getBoundingClientRect(),
					l = bounding.left,
					w = bounding.width,
					docH = document.documentElement.clientHeight,
					docW = document.documentElement.clientWidth;

		return (l + w >= docW);
	}

	function formatMoney(cents, format) {
		const moneyFormat = '${{amount}}';

	  if (typeof cents === 'string') {
	    cents = cents.replace('.', '');
	  }
	  let value = '';
	  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
	  const formatString = format || moneyFormat;

	  function formatWithDelimiters(
	    number,
	    precision = 2,
	    thousands = ',',
	    decimal = '.'
	  ) {
	    if (isNaN(number) || number == null) {
	      return 0;
	    }

	    number = (number / 100.0).toFixed(precision);

	    const parts = number.split('.');
	    const dollarsAmount = parts[0].replace(
	      /(\d)(?=(\d\d\d)+(?!\d))/g,
	      `$1${thousands}`
	    );
	    const centsAmount = parts[1] ? decimal + parts[1] : '';

	    return dollarsAmount + centsAmount;
	  }

	  switch (formatString.match(placeholderRegex)[1]) {
	    case 'amount':
	      value = formatWithDelimiters(cents, 2);
	      break;
	    case 'amount_no_decimals':
	      value = formatWithDelimiters(cents, 0);
	      break;
	    case 'amount_with_comma_separator':
	      value = formatWithDelimiters(cents, 2, '.', ',');
	      break;
	    case 'amount_no_decimals_with_comma_separator':
	      value = formatWithDelimiters(cents, 0, '.', ',');
	      break;
	  }

	  return formatString.replace(placeholderRegex, value);
	}

	return {
    setTouch: setTouch,
    isTouch: isTouch,
    debounce: debounce,
		makeSticky: makeSticky,
		showHide: showHide,
    Toggle: Toggle,
    toggleClass: toggleClass,
    Accordion: Accordion,
		fadeToggle: fadeToggle,
    fadeOut: fadeOut,
    fadeIn: fadeIn,
    getScrollbarWidth: getScrollbarWidth,
    smoothScrollTo: smoothScrollTo,
    wrapIframe: wrapIframe,
    wrapTable: wrapTable,
		scriptLoader: scriptLoader,
		scriptExists: scriptExists,
		isElementPastEdge: isElementPastEdge,
		formatMoney: formatMoney
  };
})();

WAU.a11yHelpers = (function () {

	let alreadySetUpKeyEvents = false;

	/*
	 * @description - Sets up the aria-expanded property to true and false on hover.
	 */
	function setUpAriaExpansion() {
		const ariaExpandEls = document.querySelectorAll('.js-aria-expand');

		ariaExpandEls.forEach(function (ariaExpandEl) {
			ariaExpandEl.addEventListener('mouseover', function (event) {
				ariaExpandEl.setAttribute('aria-expanded', 'true');
		});

			ariaExpandEl.addEventListener('mouseout', function (event) {
				ariaExpandEl.setAttribute('aria-expanded', 'false');
			});
		});
	}

	/*
	 * @description - Takes a parent element and focuses on the next focusable element inside of there.
	 */
	function focusOnElement(parent) {
		var focussableElements = 'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';

		const elementToFocusOn = parent.querySelector(focussableElements);

		if (elementToFocusOn) {
			elementToFocusOn.focus();
		}

	}

	function findFocusableElement(parent, element, direction) {
		const focusableElementSelectors = 'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
		const focusableElements = parent.querySelectorAll(focusableElementSelectors);
		const numOfFocusableElements = focusableElements.length;

		var elementIndex = 0;

		for (let i = 0; i < focusableElements.length; i += 1) {
			let currentElement = focusableElements[i];

			if (currentElement === element) {
				elementIndex = i;
			}
		}

		if (direction === 'next') {
			if (elementIndex === (numOfFocusableElements - 1)) {
				return focusableElements[0];
			} else {
				return focusableElements[elementIndex + 1];
			}
		}

		if (direction === 'prev') {
			if (elementIndex === 0) {
				return focusableElements[numOfFocusableElements - 1];
			} else {
				return focusableElements[elementIndex - 1];
			}
		}
	}

	/*
	 * @description - Takes a parent and a dom node and returns the next element that is focusable that is not the current element.
	 * @param parent:DOMNode
	 * @param element:DOMNode
	 * @return DOMNode
	 */
	function findNextFocusableElement(parent, element) {
		return findFocusableElement(parent, element, 'next');
	}

	function findPreviousFocusableElement(parent, element) {
		return findFocusableElement(parent, element, 'prev');
	}

			/*
	 * @description - Enables accessible keyboard navigation throughout the navigation menus.
	 */
	function setUpAccessibleNavigationMenus() {

		function closeDropdownMenus() {
			const activeMenuItems = document.querySelectorAll('.navigation__menuitem--active');
			activeMenuItems.forEach(function (activeMenuItem) {
				activeMenuItem.classList.remove('navigation__menuitem--active');
				activeMenuItem.setAttribute('aria-expanded', 'false');
			});
		}

		function closeNestedDropdownMenus() {
			//remove the class that makes the dropdown show... the active class
			const nestedDropdowns = document.querySelectorAll(".js-menuitem-with-nested-dropdown");

			nestedDropdowns.forEach(function (nestedDropdown) {
				nestedDropdown.classList.remove("dropdown__menuitem--active");
				nestedDropdown.setAttribute('aria-expanded', 'false');
			});

		}

		function addEdgeToDropdown(dropdown) {
			setTimeout(function () {
				if (WAU.Helpers.isElementPastEdge(dropdown)) {
					dropdown.classList.add("dropdown--edge");
				} else {
					dropdown.classList.remove("dropdown--edge");
				}
			}, 0);
		}

		if (!alreadySetUpKeyEvents) {
			document.addEventListener('keyup', function (event) {
				if (event.key === 'Escape') {
					const openNestedDropdownMenus = document.querySelectorAll(".dropdown__menuitem--active"),
								openDropdownMenus = document.querySelectorAll(".navigation__menuitem--active");

					event.preventDefault();

					if (openNestedDropdownMenus.length >= 1) {
						closeNestedDropdownMenus();
						return;
					}

					if (openDropdownMenus.length >= 1) {
						closeDropdownMenus();
						return;
					}

				}
			});
		}

		if (!alreadySetUpKeyEvents) {
			document.addEventListener('keydown', function (event) {
				if (event.key === 'Enter') {

					if (document.activeElement.classList.contains("js-open-dropdown-on-key") || document.activeElement.parentNode.classList.contains("js-menuitem-with-nested-dropdown")) {
						event.stopPropagation();
						event.preventDefault();
					}

					if (document.activeElement.parentNode.classList.contains("navigation__menuitem--active")) {
						closeDropdownMenus();
						return;
					}

					if (document.activeElement.parentNode.classList.contains("dropdown__menuitem--active")) {
						closeNestedDropdownMenus();
						return;
					}

					if (document.activeElement.parentNode.classList.contains("js-first-level")) {
						closeDropdownMenus();
					}

					if (document.activeElement.classList.contains("js-open-dropdown-on-key")) {
						document.activeElement.parentNode.classList.add("navigation__menuitem--active"); // Show the menu by adding the appropriate class.
						return;
					}

					if (document.activeElement.parentNode.classList.contains("js-menuitem-with-nested-dropdown")) {
						document.activeElement.parentNode.classList.add("dropdown__menuitem--active");
						addEdgeToDropdown(document.activeElement.parentNode);
						return;
					}

				}
			});
		}

		alreadySetUpKeyEvents = true;

	}

	return {
		setUpAriaExpansion: setUpAriaExpansion,
		setUpAccessibleNavigationMenus: setUpAccessibleNavigationMenus,
		focusOnElement: focusOnElement
	}

}());

WAU.Sections = (function() {
	document.querySelectorAll('[data-section-type]').forEach(function(container) {

		let callback = (entries, observer) => {
			entries.forEach(entry => {
				if ( entry.isIntersecting ) {
					loadAssets(container);
					if (container.hasAttribute('data-section-loaded') ) {
						container.setAttribute('data-section-loaded', 'true');
					}
				}
			});
		};

		let observer = new IntersectionObserver(callback);
		observer.observe(container);

		function loadAssets (container) {
			// Load section assets
			if ( container.dataset.assetUrl ) {
				const loader = new WAU.Helpers.scriptLoader();
				loader.load([container.dataset.assetUrl]).then(({length}) => {
					console.log(container.dataset.sectionType + ' script loaded');
				});
			}
		}

		document.addEventListener('shopify:section:select', function(event){
			if ( container.dataset.sectionId == event.detail.sectionId ) {
				if (container.hasAttribute('data-section-loaded') ) {
					event.target.classList.add('section--reloaded');
				}
			}
		});
		document.addEventListener('shopify:section:load', function(event){
      loadAssets(event.target.querySelector('[data-section-type]'));
			event.target.classList.add('section--reloaded');
		});

	});
})();

WAU.ProductGridVideo = {
	init: function init() {
    if (!HTMLMediaElement.hasOwnProperty('playing')) {
      Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
          get: function(){
              return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
          }
      });
    }
		document.querySelectorAll('.js-bg-video-wrapper').forEach(function(element){
      WAU.ProductGridVideo.initVideo(element);
		});
	},
	initVideo: function initVideo(element) {
		var selectorId = element.dataset.productId,
				videoUrl = element.dataset.videoUrl,
				selector = '.js-bg-video-' + selectorId;

    const wrapper = element.querySelector(selector);
    const video = element.querySelector('video');

    // Set CSS
    video.style.opacity = 1;
    video.width = wrapper.offsetWidth;
    wrapper.style.zIndex = 1;
    wrapper.style.position = 'relative';

    const observer = new IntersectionObserver(entries => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (!entry.target.playing) {
            entry.target.play();
          }
        }
      });
    });
    observer.observe(video);

	},
	destroyVideo: function destroyVideo(element) {
		element.destroy();
	},
	reinitVideo: function reinitVideo(selector, options) {
		var instance = new vidbg(selector, options);
		return instance;
	}
}

WAU.LocalizationForm = function(container) {
	function init() {
		container.querySelector('button').addEventListener('click', openSelector);
		container.querySelector('button').addEventListener('focusout', closeSelector);
		container.addEventListener('keyup', onContainerKeyUp);
		container.querySelectorAll('a').forEach(item => item.addEventListener('click', onItemClick));
	}
	function hidePanel() {
		container.querySelector('button').setAttribute('aria-expanded', 'false');
		container.querySelector('.disclosure__list-container').setAttribute('hidden', true);
	}
	function onContainerKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return;

		hidePanel();
		container.querySelector('button').focus();
	}
	function onItemClick(event) {
		event.preventDefault();
		const form = container.querySelector('form');
		container.querySelector('input[name="locale_code"], input[name="country_code"]').value = event.currentTarget.dataset.value;
		if (form) form.submit();
	}
	function openSelector() {
		container.querySelector('button').focus();
		container.querySelector('.disclosure__list-container').toggleAttribute('hidden');
		container.querySelector('button').setAttribute('aria-expanded', (container.querySelector('button').getAttribute('aria-expanded') === 'false').toString());
	}
	function closeSelector(event) {
		const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
		if (event.relatedTarget === null || shouldClose) {
			hidePanel();
		}
	}

	return init();

}

WAU.mobileSearch = function() {
  const mobileSearchElem = document.querySelector('.js--mobile-search');

  if (!mobileSearchElem) return;

  function updateAriaHidden() {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    if (isMobile) {
      mobileSearchElem.setAttribute('aria-hidden', 'false');
    } else {
      mobileSearchElem.setAttribute('aria-hidden', 'true');
    }
  }

  document.addEventListener('DOMContentLoaded', updateAriaHidden);

  window.addEventListener('resize', updateAriaHidden);
};

WAU.mobileSearch();

/*============================================================================
 Shopify Common
==============================================================================*/

if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

/*============================================================================
  Global Events & Helpers
==============================================================================*/
(function WAUInits() {
	WAU.Accordion.init();
	WAU.Slideout.init("mobile-navigation");

	document.querySelectorAll('[data-localization-form]').forEach(function(container){
    WAU.LocalizationForm(container);
  });

	document.addEventListener('DOMContentLoaded', function() {
		if ( document.querySelectorAll('.js-bg-video-wrapper') ) {
			WAU.ProductGridVideo.init();
		}
	});

	document.addEventListener('shopify:section:select', function(event){
		if ( document.querySelectorAll('.js-bg-video-wrapper') ) {
			WAU.ProductGridVideo.init();
		}
		if ( event.target.querySelector('[data-localization-form]') ) {
      WAU.LocalizationForm(event.target.querySelector('[data-localization-form]'));
    }
    // Reinitialize accessibility helpers when a section is loaded
    WAU.a11yHelpers.setUpAccessibleNavigationMenus();
    WAU.a11yHelpers.setUpAriaExpansion();
	});

  document.addEventListener('shopify:section:load', function(event){
    // Reinitialize accessibility helpers when a section is loaded
    WAU.a11yHelpers.setUpAccessibleNavigationMenus();
    WAU.a11yHelpers.setUpAriaExpansion();
    const localizationForms = event.target.querySelectorAll('[data-localization-form]');
    if (localizationForms.length > 0) {
      localizationForms.forEach(function(form) {
        WAU.LocalizationForm(form);
      });
    }
  });

  if (window.Shopify && window.Shopify.theme && navigator.sendBeacon && window.Shopify.designMode) {
    if (!sessionStorage.getItem('beaconSent')) {
      try {
        const url = 'https://api.weareunderground.com/beacon';

        const themeName = Shopify.theme?.name || 'Unknown';
        const themeVersion = Shopify.theme?.schema_version || 'Unknown';

        console.log("Theme Name:", themeName, "Theme Version:", themeVersion); 

        const params = new URLSearchParams({
          shop: window.Shopify.shop,
          themeName: `${themeName} v${themeVersion}`,
          role: window.Shopify.theme.role,
          route: window.location.pathname,
          themeId: window.Shopify.theme.id,
          themeStoreId: window.Shopify.theme.theme_store_id || 0,
          isThemeEditor: !!window.Shopify.designMode
        });

        if (!navigator.sendBeacon(url, params)) {
          fetch(url, { method: 'POST', body: params }).catch(() => {});
        }
        sessionStorage.setItem('beaconSent', 'true');
      } catch (error) {
        // errors will be silently ignored.
      }
    }
  }

})();

(function helperRteFormat() {
  WAU.Helpers.wrapIframe({
		iframes: document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]'),
    iframeWrapperClass: 'video-wrapper'
  });

	WAU.Helpers.wrapIframe({
		iframes: document.querySelectorAll('.rte iframe[src*="player.vimeo"]'),
		iframeWrapperClass: 'video-wrapper'
	});

  WAU.Helpers.wrapTable({
		tables: document.querySelectorAll('.rte table'),
    tableWrapperClass: 'table-wrapper'
  });
})();

(function helperThemeVersion() {
  /* Log Theme Version */
  log = function() {
      var args = Array.prototype.slice.call(arguments);
      args.unshift(console);
      return Function.prototype.bind.apply(console.log, args);
  }

  log("RYNOR Version 5.0.0 by FLYNN", {bar: 1})();
})();

(function helperNotifyForm() {
  var notifySubmitBtns = document.querySelectorAll('.js-notify-submit');
  notifySubmitBtns.forEach(function(btn){
    btn.addEventListener('click', function(event) {
      event.preventDefault();
      var prod = event.target.dataset.productId;
      var currentUrl = window.location.href;
      var form = btn.closest('form');

      submitForm(form, currentUrl, prod);

    });
  });
  let notifySubmitForms = document.querySelectorAll('.js-notify-contact-form');
  notifySubmitForms.forEach(function(form){
    var prodId = sessionStorage.getItem('form_product')

    if ( form.id == prodId ) {
      // Show success msg
      form.querySelector('.notify-form__success-wrapper').style.display = 'block';
      // Hide subscribe form
      form.querySelector('.notify-form__subscribe-wrapper').style.display = 'none';
      // Hide form toggle btn
      if (form.parentNode.previousSibling) {
        form.parentNode.previousSibling.style.display = 'none';
      }
    } else {
      form.querySelector('.notify-form__success-wrapper').style.display = 'none';
      form.querySelector('.notify-form__subscribe-wrapper').style.display = 'block';
    }
  });

  if ( window.location.href.indexOf("collections") > -1 && window.location.href.indexOf("contact_posted") > -1 && sessionStorage.getItem('prev_url') !== null ) {
    window.location.href = sessionStorage.getItem('prev_url');
  }

  function submitForm(form, currentUrl, prod) {
    // Check if valid using HTML5 checkValidity() builtin function
    if (form.checkValidity()) {
      storeData(currentUrl, prod);
      form.submit();
    } else {
      var errorMsg = form.querySelector('.js-form-error');
      WAU.Helpers.fadeIn(errorMsg, 'block');
      setTimeout(function(){ WAU.Helpers.fadeOut(errorMsg); }, 2000);
    }

    return false
  }

  function storeData(currentUrl, prod) {
    sessionStorage.setItem('prev_url', currentUrl);
    sessionStorage.setItem('form_product', prod);
  }

})();

(function initModals() {
	if ( document.querySelector('[data-wau-modal="new-address"]') ) {
		WAU.Modal.init("new-address");
	}

	var buildModals = document.querySelectorAll('[data-wau-modal-content]');
	if ( buildModals ) {
		buildModals.forEach((item, i) => {
			var contentType = item.dataset.wauModalContent;
		});
	}

	var modals = document.querySelectorAll('[data-wau-modal]');
	if ( modals ) {
		modals.forEach((item, i) => {
			if (item.dataset.wauModal.includes("edit-address")) {
				WAU.Modal.init(item.dataset.wauModal);
			}
		});
	}
})();

(function formValidation() {
	/* Form Validation */
	var validateForm = function(submitEvent) {
	  if (!submitEvent.target.checkValidity()) {
	    submitEvent.preventDefault();
	    submitEvent.stopImmediatePropagation();
	    submitEvent.stopPropagation();

	    var form = submitEvent.target,
	        elements = form.elements;

	    for (var index = 0, len = elements.length; index < len; index++) {
	      var element = elements[index];
	      if (element.willValidate === true && element.validity.valid !== true) {
	        var message = element.validationMessage,
	            parent  = element.parentNode,
	            div     = document.createElement('small');

	      div.appendChild(document.createTextNode(message));
	       div.classList.add('validation-message');

	       parent.insertBefore(div, element.nextSibling);

	       element.focus();
	       break;
	     }
	    }
	  } else {
	    return true;
	  }
	};

	document.addEventListener('DOMContentLoaded', function() {
	  var forms = document.querySelectorAll('form');

	  for (var index = forms.length - 1; index >= 0; index--) {
	    var form = forms[index];

      if (form.classList.contains('js-no-validate')) return false;
	    form.noValidate = true;
	    form.addEventListener('submit', validateForm);
	  }
	});
})();


const ViewedProducts = (function() {

  let Constructor = function(params) {
    const publicAPIs = {};

    // default configs
    var config = {
      howManyToShow: 3,
      howManyToStoreInMemory: 30,
      wrapperId: "recently-viewed-products",
      onComplete: null,
    };

    // array containing recently viewed products
    var productHandleQueue = [];

    // wrapper element that displays the products
    var wrapper = null;

    // variable to keep track of how many products have been shown
    var shown = 0;

    // Handle cookie related operations
    var cookie = {
      configuration: {
        expires: 90,
        path: "/",
        domain: window.location.hostname,
        sameSite: "none",
        secure: true
      },
      name: "shopify_recently_viewed",
      write: function(recentlyViewed) {
        Cookies.set(this.name, recentlyViewed.join(" "), this.configuration);
      },
      read: function() {
        var recentlyViewed = [];
        var cookieValue = Cookies.get(this.name);
        if (cookieValue !== undefined && cookieValue !== '') {
          recentlyViewed = cookieValue.split(" ");
        }
        return recentlyViewed;
      },
      destroy: function() {
        Cookies.remove(this.name, null, this.configuration);
      },
      remove: function(productHandle) {
        var recentlyViewed = this.read();
        var position = recentlyViewed.indexOf(productHandle);
        if (position !== -1) {
          recentlyViewed.splice(position, 1);
          this.write(recentlyViewed);
        }
      },
    };

    // Reveal wrapper element and show recently viewed products and run call back if provided one.
    var finalize = function() {
      // Check if any products were shown.
      if (shown > 0) {

        // Remove hidden class if it exists
        if (wrapper.classList.contains('recently-viewed-products--hidden')) {
          wrapper.classList.remove('recently-viewed-products--hidden');
        }

        // If we have a callback.
        if (config.onComplete) {
          try {
            config.onComplete();
          } catch (error) {}
        }
      } else {
        console.log('No recently viewed products to show');
        return false;
      }
    };

    // Format the product listing template by converting it into a DOM node, determining it's CSS grid classes and then wrapping it with those classes
    var formatTemplate = (product) => {

      // Check if the product data was passed
      if (!product) {
        console.log('Error. Must provide a valid product in order to format it');
        return false;
      }

      //
      // Convert the product into a node.
      //

      // Parse the product HTML into a DOM node.
      var parser = new DOMParser();
      var doc = parser.parseFromString(product, 'text/html');

      // Get the template element.
      var template = doc.querySelector('[data-html="listing"]');

      // Check if we have a valid template element.
      if (!template) {
        console.log('Error. Could not find template elment.');
        return false;
      }

      //
      // Wrap the product in a div with grid classes.
      //

      // Create div element
      let productWrap = document.createElement('div');


      // Apply classes
      productWrap.classList.add('product', 'product-loop__item', 'relative', 'recently-viewed-products__product', 'js-product-listing', 'product-loop__item--vertical');

      // Append product in wrapper element
      productWrap.appendChild(template.content);

      // Return the final product template
      return productWrap;
    };


    // Use fetch api to get product data and add it to the list
    var moveAlong = function() {

      if (productHandleQueue.length && shown < config.howManyToShow) {

        // Build fetch url
        let furl =  `${window.Shopify.routes.root}products/${productHandleQueue[0]}?view=listing`;

        // Fetch the product data
        fetch(furl)
          .then((response) => {
            // Convert data to text
            return response.text();
          })
          .then((response) => {

            // Get the formated product node with the data
            let product = formatTemplate(response);

            // Append the product to the wrapper element
            wrapper.appendChild(product);

            // Remove first element from the array
            productHandleQueue.shift();

            // Increment shown
            shown++;

            // Recursively call function
            moveAlong();
          })
          .catch((error) => {
            // Log error
            console.log(error.message);
            // Remove first product from the array from the cookie
            cookie.remove(productHandleQueue[0]);
            productHandleQueue.shift();
            moveAlong();
          });
      } else {
        finalize();
      }
    };

    publicAPIs.showRecentlyViewed = function(params) {
      var params = params || {};

      // Update defaults.
      config = Object.assign(config, params);

      // Reset
      shown = 0;
      productHandleQueue = [];
      wrapper = null;
      template = null;

      // Read cookie.
      productHandleQueue = cookie.read();

      // Get the wrapper element
      wrapper = document.getElementById(config.wrapperId);

      // If we have any to show.
      if (config.howManyToShow && wrapper) {
        // Getting each product with an Ajax call and rendering it on the page.
        moveAlong();
      }
    };
    publicAPIs.getConfig = function() {
      return config;
    };
    publicAPIs.clearList = function() {
      cookie.destroy();
    };
    publicAPIs.getCount = function() {
      let productHandleQueue = cookie.read();
      return productHandleQueue.length;
    };

    publicAPIs.showRecentlyViewed(params);

    return publicAPIs;
  };

  return Constructor;
})();


Shopify.RecordViewedProducts = (function() {

  // default configs
  var config = {
    howManyToShow: 3,
    howManyToStoreInMemory: 30,
    wrapperId: "recently-viewed-products",
    onComplete: null,
  };

  // array containing recently viewed products
  var productHandleQueue = [];

  // wrapper element that displays the products
  var wrapper = null;

  // variable to keep track of how many products have been shown
  var shown = 0;

  // Handle cookie related operations
  var cookie = {
    configuration: {
      expires: 90,
      path: "/",
      domain: window.location.hostname,
      sameSite: "none",
      secure: true
    },
    name: "shopify_recently_viewed",
    write: function(recentlyViewed) {
      Cookies.set(this.name, recentlyViewed.join(" "), this.configuration);
    },
    read: function() {
      var recentlyViewed = [];
      var cookieValue = Cookies.get(this.name);
      if (cookieValue !== undefined && cookieValue !== '') {
        recentlyViewed = cookieValue.split(" ");
      }
      return recentlyViewed;
    },
    destroy: function() {
      Cookies.remove(this.name, null, this.configuration);
    },
    remove: function(productHandle) {
      var recentlyViewed = this.read();
      var position = recentlyViewed.indexOf(productHandle);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    },
  };

  return {
    getConfig: function() {
      return config;
    },
    clearList: function() {
      cookie.destroy();
    },
    getCount: function() {
      let productHandleQueue = cookie.read();
      return productHandleQueue.length;
    },
    recordRecentlyViewed: function(params) {

      var params = params || {};

      // Update defaults.
      config = Object.assign(config, params);

      // Read cookie.
      var recentlyViewed = cookie.read();

      // If we are on a product page.
      if (window.location.pathname.indexOf("/products/") !== -1) {

        // What is the product handle on this page.
        var urlPathname = new URL(window.location).pathname;
        var urlArray = decodeURIComponent(urlPathname).split('/');
        var productHandle = urlArray[urlArray.indexOf('products') + 1];
        if (!productHandle) {
          console.log('Error, no product handle found.');
          return false;
        }

        // In what position is that product in memory.
        var position = recentlyViewed.indexOf(productHandle);


        // If not in memory. (product handle was not found in the recentlyv)
        if (position === -1) {

          // Add product at the start of the list.
          recentlyViewed.unshift(productHandle);

          // Only keep what we need.
          recentlyViewed = recentlyViewed.splice(
            0,
            config.howManyToStoreInMemory
          );
        } else {
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);
        }

        // Update cookie.
        cookie.write(recentlyViewed);
      }
    },
  };
})();

  document.addEventListener('DOMContentLoaded', function(){
    var signup = document.querySelector('.signup-link');
    var form   = document.getElementById('newsletter-form');
    if (!signup || !form) return;
    signup.addEventListener('click', function(e){
      e.preventDefault();
      signup.style.display = 'none';
      form.style.display   = 'block';
    });
  });
(function () {
  if (window.RynorCardSlider && window.RynorCardSlider.__version === '3.3.0') {
    return;
  }

  var sliderState = new WeakMap();
  var sliderObserver = null;
  var domObserver = null;
  var resizeQueued = false;
  var raf = window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : function (callback) {
        return setTimeout(callback, 16);
      };
  var caf = window.cancelAnimationFrame
    ? window.cancelAnimationFrame.bind(window)
    : function (frameId) {
        clearTimeout(frameId);
      };
  var ric = window.requestIdleCallback
    ? window.requestIdleCallback.bind(window)
    : function (callback) {
        return setTimeout(function () {
          callback({
            didTimeout: true,
            timeRemaining: function () {
              return 0;
            },
          });
        }, 80);
      };

  var canHover = false;
  var reduceMotion = false;
  var enhancedSliderSelector = '.rynor-card-slider[data-rynor-card-slider]';

  try {
    canHover =
      window.matchMedia &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  } catch (error) {
    canHover = false;
  }

  try {
    reduceMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (error) {
    reduceMotion = false;
  }

  // Hover photo swap: decided per event, so a real mouse works even on PCs that Chrome reports as
  // touch-only (see html.ry-mouse in layout/theme.liquid). Touch and pen taps never trigger it.
  function isMousePointer(event) {
    if (event && event.pointerType) return event.pointerType === 'mouse';
    return canHover;
  }

  function desktopCardSliderMatches() {
    try {
      if (window.matchMedia) {
        return window.matchMedia('(min-width: 1000px)').matches;
      }
    } catch (error) {}

    return (window.innerWidth || document.documentElement.clientWidth || 0) >= 1000;
  }

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function clampIndex(index, total) {
    if (!total) return 0;
    if (index < 0) return total - 1;
    if (index >= total) return 0;
    return index;
  }

  function forwardDistance(fromIndex, toIndex, total) {
    if (!total) return 0;
    return (toIndex - fromIndex + total) % total;
  }

  function backwardDistance(fromIndex, toIndex, total) {
    if (!total) return 0;
    return (fromIndex - toIndex + total) % total;
  }

  function shortestDirection(fromIndex, toIndex, total) {
    var forward = forwardDistance(fromIndex, toIndex, total);
    var backward = backwardDistance(fromIndex, toIndex, total);

    if (!forward && !backward) return 0;
    return forward <= backward ? 1 : -1;
  }

  function setImageHints(img, loadingValue, priorityValue) {
    if (!img) return;

    try {
      img.decoding = 'async';
    } catch (error) {}

    if (loadingValue) {
      try {
        img.loading = loadingValue;
      } catch (error) {}
      img.setAttribute('loading', loadingValue);
    }

    if (priorityValue) {
      try {
        if ('fetchPriority' in img) {
          img.fetchPriority = priorityValue;
        }
      } catch (error) {}
      img.setAttribute('fetchpriority', priorityValue);
    }
  }

  function resolveImageSource(img) {
    if (!img) {
      return {
        src: '',
        srcset: '',
        sizes: '',
      };
    }

    return {
      src: img.currentSrc || img.getAttribute('src') || '',
      srcset: img.getAttribute('srcset') || '',
      sizes: img.getAttribute('sizes') || '',
    };
  }

  function decodeImage(img) {
    if (!img || typeof img.decode !== 'function') {
      return Promise.resolve();
    }

    return img.decode().catch(function () {
      return undefined;
    });
  }

  function warmImage(img, priorityValue) {
    if (!img) {
      return Promise.resolve();
    }

    if (img.dataset.rynorWarmState === 'done' && img.complete && img.naturalWidth > 0) {
      return Promise.resolve(img);
    }

    if (img._rynorWarmPromise) {
      return img._rynorWarmPromise;
    }

    setImageHints(img, 'eager', priorityValue || 'low');
    img.dataset.rynorWarmState = 'warming';

    img._rynorWarmPromise = new Promise(function (resolve) {
      var settled = false;
      var source = resolveImageSource(img);

      function finalize() {
        if (settled) return;
        settled = true;

        decodeImage(img).finally(function () {
          img.dataset.rynorWarmState = 'done';
          resolve(img);
        });
      }

      if (img.complete && img.naturalWidth > 0) {
        finalize();
        return;
      }

      img.addEventListener('load', finalize, { once: true });
      img.addEventListener('error', finalize, { once: true });

      if (!source.src && !source.srcset) {
        finalize();
        return;
      }

      var preloader = new Image();

      try {
        preloader.decoding = 'async';
      } catch (error) {}

      try {
        if ('fetchPriority' in preloader) {
          preloader.fetchPriority = priorityValue || 'low';
        }
      } catch (error) {}

      if (source.sizes) preloader.sizes = source.sizes;
      if (source.srcset) preloader.srcset = source.srcset;
      if (source.src) preloader.src = source.src;

      preloader.onload = finalize;
      preloader.onerror = finalize;
    });

    return img._rynorWarmPromise;
  }

  function syncDots(state, activeIndex) {
    if (!state || !state.dots || !state.dots.length) return;

    var total = state.slides && state.slides.length ? state.slides.length : state.dots.length;
    var normalizedIndex = clampIndex(activeIndex, total);

    if (state.dotIndex === normalizedIndex && state.dotsInitialized) {
      return;
    }

    state.dotIndex = normalizedIndex;
    state.dotsInitialized = true;

    state.dots.forEach(function (dot, dotIndex) {
      dot.classList.toggle('is-active', dotIndex === normalizedIndex);
      dot.setAttribute('aria-hidden', 'true');
      if (!dot.hasAttribute('data-index')) {
        dot.setAttribute('data-index', String(dotIndex));
      }
    });
  }

  function syncDotsFromDrag(state, offset) {
    if (!state || !state.touchDragging || !state.slides || state.slides.length < 2) return;

    var width = getViewportWidth(state);
    if (!width) return;

    var previewThreshold = Math.min(Math.max(width * 0.12, 18), 46);
    var previewIndex = state.current;

    if (offset <= -previewThreshold) {
      previewIndex = clampIndex(state.current + 1, state.slides.length);
    } else if (offset >= previewThreshold) {
      previewIndex = clampIndex(state.current - 1, state.slides.length);
    }

    syncDots(state, previewIndex);
  }

  function clearInstantSwitch(state) {
    if (!state || !state.slider) return false;

    var hadInstantSwitch = state.slider.classList.contains('is-instant-switch');

    if (state.instantResetTimer) {
      clearTimeout(state.instantResetTimer);
      state.instantResetTimer = null;
    }

    state.slider.classList.remove('is-instant-switch');
    return hadInstantSwitch;
  }

  function applyInstantSwitch(state, callback) {
    if (!state || !state.slider) {
      if (typeof callback === 'function') callback();
      return;
    }

    if (state.instantResetTimer) {
      clearTimeout(state.instantResetTimer);
      state.instantResetTimer = null;
    }

    state.slider.classList.add('is-instant-switch');

    if (typeof callback === 'function') {
      callback();
    }

    if (typeof state.slider.offsetWidth !== 'undefined') {
      state.slider.offsetWidth;
    }

    state.instantResetTimer = setTimeout(function () {
      if (state && state.slider) {
        state.slider.classList.remove('is-instant-switch');
      }
      state.instantResetTimer = null;
    }, 40);
  }

  function warmAdditionalSlides(state, immediate) {
    if (!state || !state.active || state.images.length < 2) {
      return Promise.resolve();
    }

    var promises = [];

    state.images.forEach(function (img, index) {
      if (!img || index === 0) return;
      promises.push(warmImage(img, immediate || index === 1 ? 'high' : 'low'));
    });

    return Promise.all(promises);
  }

  function prewarmNearbySlides(state) {
    if (!state || !state.active || state.prewarmed) return;
    state.prewarmed = true;
    ric(function () {
      warmAdditionalSlides(state, false);
    });
  }

  function getCardRoot(slider) {
    if (!slider || typeof slider.closest !== 'function') return null;
    return slider.closest('article.product-loop__item[data-card]');
  }

  function isDesktopOnlySlider(slider) {
    if (!slider) return false;
    if (slider.hasAttribute('data-rynor-card-desktop-only')) return true;

    var card = getCardRoot(slider);
    return !!(card && card.hasAttribute('data-rynor-card-desktop-only'));
  }

  function shouldActivateSlider(state) {
    if (!state) return false;
    if (!state.desktopOnly) return true;
    return desktopCardSliderMatches();
  }

  function setCardSliderEnabled(state, enabled) {
    if (!state || !state.card) return;

    if (enabled) {
      state.card.setAttribute('data-rynor-card-enabled', '');
      return;
    }

    state.card.removeAttribute('data-rynor-card-enabled');
  }

  function resetSlideState(state) {
    if (!state || !state.slides) return;

    state.slides.forEach(function (slide, index) {
      slide.classList.remove(
        'is-entering',
        'is-leaving',
        'is-entering-next',
        'is-entering-prev',
        'is-leaving-next',
        'is-leaving-prev',
        'is-ready',
        'rynor-card-slide--clone'
      );

      if (!slide.hasAttribute('data-index')) {
        slide.setAttribute('data-index', String(index));
      }
      slide.dataset.rynorIndex = String(index);
    });
  }

  function deactivateSlider(state) {
    if (!state) return;

    finishInFlightAnimation(state);
    clearInstantSwitch(state);

    if (state.cleanupTimer) {
      clearTimeout(state.cleanupTimer);
      state.cleanupTimer = null;
    }

    if (state.instantResetTimer) {
      clearTimeout(state.instantResetTimer);
      state.instantResetTimer = null;
    }

    removeTrackClones(state);
    resetSlideState(state);

    if (state.track) {
      state.track.style.transform = '';
    }

    if (state.viewport && state.viewport.parentNode) {
      var insertBeforeNode = state.viewport;
      state.slides.forEach(function (slide) {
        state.slider.insertBefore(slide, insertBeforeNode);
      });
      state.viewport.remove();
    }

    state.viewport = null;
    state.track = null;
    state.prependedClones = 0;
    state.current = 0;
    state.pendingIndex = null;
    state.isAnimating = false;
    state.finishAnimation = null;
    state.prewarmed = false;
    state.active = false;

    resetTouchTracking(state);
    state.slider.classList.remove('is-track-mode', 'is-animating', 'is-instant-switch', 'is-touch-dragging', 'is-sliding');
    refreshActiveState(state, 0);
    setCardSliderEnabled(state, false);
  }

  function activateSlider(state) {
    if (!state) return null;
    if (state.active) return state;

    state.active = true;
    setCardSliderEnabled(state, true);
    buildTrack(state);
    settleToCurrent(state);
    bindSlider(state);
    observeSlider(state);
    primeAboveFold(state);
    return state;
  }

  function syncSliderActivation(state) {
    if (!state) return null;

    if (shouldActivateSlider(state)) {
      return activateSlider(state);
    }

    deactivateSlider(state);
    return state;
  }

  function getSliderObserver() {
    if (sliderObserver || !('IntersectionObserver' in window)) {
      return sliderObserver;
    }

    sliderObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && entry.intersectionRatio <= 0) return;
          var state = ensureSlider(entry.target);
          if (!state) return;
          prewarmNearbySlides(state);
        });
      },
      {
        rootMargin: '560px 0px 560px 0px',
        threshold: 0.01,
      }
    );

    return sliderObserver;
  }

  function observeSlider(state) {
    var observer = getSliderObserver();

    if (observer) {
      observer.observe(state.slider);
      return;
    }

    prewarmNearbySlides(state);
  }

  function primeAboveFold(state) {
    if (!state || !state.active || typeof state.slider.getBoundingClientRect !== 'function') return;

    var rect = state.slider.getBoundingClientRect();
    var viewportHeight =
      window.innerHeight || document.documentElement.clientHeight || 0;

    if (rect.top < viewportHeight * 1.5 && rect.bottom > viewportHeight * -0.25) {
      state.prewarmed = true;
      if (state.images[state.hoverIndex]) {
        warmImage(state.images[state.hoverIndex], 'high');
      }
      warmAdditionalSlides(state, true);
    }
  }

  function refreshActiveState(state, activeIndex) {
    if (!state) return;

    state.slides.forEach(function (slide, slideIndex) {
      var isActive = slideIndex === activeIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    syncDots(state, activeIndex);
  }

  function buildTrack(state) {
    if (!state || state.track) return;

    var viewport = document.createElement('div');
    viewport.className = 'rynor-card-viewport';

    var track = document.createElement('div');
    track.className = 'rynor-card-track';

    var firstSlide = state.slides[0];
    state.slider.insertBefore(viewport, firstSlide);
    viewport.appendChild(track);

    resetSlideState(state);

    state.slides.forEach(function (slide) {
      track.appendChild(slide);
    });

    state.viewport = viewport;
    state.track = track;
    state.slider.classList.add('is-track-mode');
  }

  function getViewportWidth(state) {
    if (!state) return 0;

    var width = 0;

    if (state.viewport && typeof state.viewport.getBoundingClientRect === 'function') {
      width = state.viewport.getBoundingClientRect().width || 0;
    }

    if (!width && state.slider && typeof state.slider.getBoundingClientRect === 'function') {
      width = state.slider.getBoundingClientRect().width || 0;
    }

    if (!width) {
      width =
        (state.viewport && state.viewport.clientWidth) ||
        state.slider.clientWidth ||
        0;
    }

    /*
      Keep the live fractional width for drag thresholds / velocity decisions.
      The settled conveyor transform itself now uses percentage steps so hover and
      arrow navigation stay aligned on fractional card widths.
    */
    return Math.max(0, Number(width) || 0);
  }

  function buildTrackTranslate(visualIndex, pixelOffset) {
    var index = Number(visualIndex) || 0;
    var offset = Number(pixelOffset) || 0;
    var percentage = -100 * index;

    if (!offset) {
      return 'translate3d(' + percentage + '%, 0, 0)';
    }

    return 'translate3d(calc(' + percentage + '%' + (offset < 0 ? ' - ' : ' + ') + Math.abs(offset) + 'px), 0, 0)';
  }

  function flushNode(node) {
    if (!node || typeof node.offsetWidth === 'undefined') return;
    node.offsetWidth;
  }

  function removeTrackClones(state) {
    if (!state || !state.track) return;

    toArray(state.track.querySelectorAll('.rynor-card-slide--clone')).forEach(function (clone) {
      clone.remove();
    });

    state.prependedClones = 0;
  }

  function buildSlideClone(state, slideIndex) {
    var source = state.slides[clampIndex(slideIndex, state.slides.length)];
    if (!source) return null;

    var clone = source.cloneNode(true);
    clone.classList.remove('is-active');
    clone.classList.add('rynor-card-slide--clone');
    clone.setAttribute('aria-hidden', 'true');

    var img = clone.querySelector('img');
    if (img) {
      setImageHints(img, 'eager', 'low');
    }

    return clone;
  }

  function setTrackOffset(state, visualIndex, immediate) {
    if (!state || !state.track) return;

    state.slider.classList.toggle('is-animating', !immediate && !reduceMotion);
    state.track.style.transform = buildTrackTranslate(visualIndex, 0);
  }

  function settleToCurrent(state) {
    if (!state) return;

    if (state.cleanupTimer) {
      clearTimeout(state.cleanupTimer);
      state.cleanupTimer = null;
    }

    removeTrackClones(state);
    state.slider.classList.remove('is-animating', 'is-touch-dragging', 'is-sliding');
    state.isAnimating = false;
    state.pendingIndex = null;
    state.finishAnimation = null;
    refreshActiveState(state, state.current);
    setTrackOffset(state, state.current, true);
  }

  function finishInFlightAnimation(state) {
    if (!state || typeof state.finishAnimation !== 'function') return;
    state.finishAnimation(true);
  }

  function clearTouchGesture(state) {
    if (!state) return;

    state.touchStartX = null;
    state.touchStartY = null;
    state.touchLastX = null;
    state.touchLastTime = 0;
    state.touchVelocityX = 0;
    state.touchLock = null;
    state.dragCurrentOffset = 0;
  }

  function resetTouchTracking(state) {
    if (!state) return;

    clearTouchGesture(state);
    state.touchDragging = false;
    state.dragBaseVisualIndex = null;

    if (state.dragFrame) {
      try {
        caf(state.dragFrame);
      } catch (error) {}
      state.dragFrame = null;
    }

    if (state.slider) {
      state.slider.classList.remove('is-touch-dragging');
    }
  }

  function warmAdjacentSlides(state) {
    if (!state || !state.active || state.images.length < 2) {
      return Promise.resolve();
    }

    var total = state.images.length;
    var currentIndex = typeof state.pendingIndex === 'number' ? state.pendingIndex : state.current;
    var nextIndex = clampIndex(currentIndex + 1, total);
    var prevIndex = clampIndex(currentIndex - 1, total);
    var promises = [];

    if (state.images[nextIndex]) {
      promises.push(warmImage(state.images[nextIndex], 'high'));
    }

    if (prevIndex !== nextIndex && state.images[prevIndex]) {
      promises.push(warmImage(state.images[prevIndex], 'high'));
    }

    return Promise.all(promises);
  }

  function beginTouchDrag(state) {
    if (!state || !state.active || state.touchDragging || state.slides.length < 2) {
      return;
    }

    buildTrack(state);
    removeTrackClones(state);

    var prependClone = buildSlideClone(state, state.current - 1);
    if (prependClone) {
      state.track.insertBefore(prependClone, state.track.firstChild);
      state.prependedClones = 1;
    }

    var appendClone = buildSlideClone(state, state.current + 1);
    if (appendClone) {
      state.track.appendChild(appendClone);
    }

    state.touchDragging = true;
    state.slider.classList.add('is-touch-dragging');
    state.slider.classList.remove('is-animating');
    state.isAnimating = false;
    state.pendingIndex = null;
    state.finishAnimation = null;
    state.dragBaseVisualIndex = state.current + state.prependedClones;

    setTrackOffset(state, state.dragBaseVisualIndex, true);
    flushNode(state.track);
  }

  function renderTouchDrag(state, offset) {
    if (!state || !state.touchDragging || !state.track) return;

    var width = getViewportWidth(state);
    if (!width || !state.dragBaseVisualIndex) return;

    var maxDistance = width * 1.15;
    var limitedOffset = offset;

    if (Math.abs(limitedOffset) > maxDistance) {
      limitedOffset = maxDistance * (limitedOffset < 0 ? -1 : 1);
    }

    state.dragCurrentOffset = limitedOffset;
    state.track.style.transform = buildTrackTranslate(state.dragBaseVisualIndex, limitedOffset);
    syncDotsFromDrag(state, limitedOffset);
  }

  function queueTouchDrag(state, offset) {
    if (!state) return;

    state.dragQueuedOffset = offset;
    state.dragCurrentOffset = offset;

    if (state.dragFrame) return;

    state.dragFrame = raf(function () {
      state.dragFrame = null;
      renderTouchDrag(state, state.dragQueuedOffset || 0);
    });
  }

  function finishTouchDrag(state, cancelled) {
    if (!state) return;

    var wasDragging = state.touchDragging;
    var width = getViewportWidth(state);
    var baseVisualIndex = state.dragBaseVisualIndex;
    var deltaX = state.dragCurrentOffset || 0;
    var velocityX = state.touchVelocityX || 0;
    var targetIndex = state.current;
    var endVisualIndex = baseVisualIndex;
    var commit = false;

    clearTouchGesture(state);

    if (!wasDragging || !state.track || !width || !baseVisualIndex) {
      resetTouchTracking(state);
      settleToCurrent(state);
      return;
    }

    if (!cancelled) {
      var travelThreshold = Math.min(Math.max(width * 0.16, 44), 84);
      var velocityThreshold = 0.35;

      if (deltaX <= -travelThreshold || velocityX <= -velocityThreshold) {
        targetIndex = clampIndex(state.current + 1, state.slides.length);
        endVisualIndex = baseVisualIndex + 1;
        commit = true;
      } else if (deltaX >= travelThreshold || velocityX >= velocityThreshold) {
        targetIndex = clampIndex(state.current - 1, state.slides.length);
        endVisualIndex = baseVisualIndex - 1;
        commit = true;
      }
    }

    syncDots(state, commit ? targetIndex : state.current);
    resetTouchTracking(state);

    if (reduceMotion) {
      state.current = targetIndex;
      settleToCurrent(state);
      if (commit) {
        warmAdditionalSlides(state, false);
      }
      return;
    }

    state.slider.classList.add('is-animating');
    state.isAnimating = true;
    state.pendingIndex = targetIndex;

    var done = false;

    function finish() {
      if (done) return;
      done = true;

      state.track.removeEventListener('transitionend', handleTransitionEnd);
      state.current = targetIndex;
      settleToCurrent(state);
      if (commit) {
        warmAdditionalSlides(state, false);
      }
    }

    function handleTransitionEnd(event) {
      if (event.target !== state.track) return;
      if (event.propertyName !== 'transform') return;
      finish();
    }

    state.finishAnimation = finish;
    state.track.addEventListener('transitionend', handleTransitionEnd);
    state.cleanupTimer = setTimeout(finish, 760);

    raf(function () {
      state.track.style.transform = buildTrackTranslate(endVisualIndex, 0);
    });
  }

  function jumpTo(state, requestedIndex, instantMode) {
    if (!state) return;

    finishInFlightAnimation(state);
    clearInstantSwitch(state);

    state.current = clampIndex(requestedIndex, state.slides.length);

    var apply = function () {
      settleToCurrent(state);
      warmAdditionalSlides(state, false);
    };

    if (instantMode) {
      applyInstantSwitch(state, apply);
    } else {
      apply();
    }
  }

  function animateStep(state, targetIndex, direction) {
    finishInFlightAnimation(state);
    clearInstantSwitch(state);

    var total = state.slides.length;
    var width = getViewportWidth(state);

    if (!total || total < 2 || !width || reduceMotion) {
      jumpTo(state, targetIndex, false);
      return;
    }

    buildTrack(state);
    removeTrackClones(state);

    var startVisualIndex = state.current;
    var endVisualIndex = targetIndex;

    if (direction > 0 && state.current === total - 1 && targetIndex === 0) {
      var appendClone = buildSlideClone(state, 0);
      if (appendClone) {
        state.track.appendChild(appendClone);
      }
      startVisualIndex = state.current;
      endVisualIndex = total;
    } else if (direction < 0 && state.current === 0 && targetIndex === total - 1) {
      var prependClone = buildSlideClone(state, total - 1);
      if (prependClone) {
        state.track.insertBefore(prependClone, state.track.firstChild);
        state.prependedClones = 1;
      }
      startVisualIndex = 1;
      endVisualIndex = 0;
    }

    // v3.3: keep both photos painted for the whole slide (see the v3.3 block in
    // component-product-grid.css). settleToCurrent() removes it when the slide ends.
    state.slider.classList.add('is-sliding');
    refreshActiveState(state, targetIndex);
    state.isAnimating = true;
    state.pendingIndex = targetIndex;
    state.slider.classList.remove('is-animating');
    state.track.style.transform = buildTrackTranslate(startVisualIndex, 0);
    flushNode(state.track);

    var done = false;

    function finish() {
      if (done) return;
      done = true;

      state.track.removeEventListener('transitionend', handleTransitionEnd);
      state.current = targetIndex;
      settleToCurrent(state);
      warmAdditionalSlides(state, false);
    }

    function handleTransitionEnd(event) {
      if (event.target !== state.track) return;
      if (event.propertyName !== 'transform') return;
      finish();
    }

    state.finishAnimation = finish;
    state.track.addEventListener('transitionend', handleTransitionEnd);
    state.cleanupTimer = setTimeout(finish, 760);

    raf(function () {
      state.slider.classList.add('is-animating');
      state.track.style.transform = buildTrackTranslate(endVisualIndex, 0);
    });
  }

  function goTo(state, requestedIndex, options) {
    if (!state || !state.active || !state.slides.length) {
      return Promise.resolve();
    }

    var nextIndex = clampIndex(requestedIndex, state.slides.length);

    if (nextIndex === state.current && !state.isAnimating) {
      if (options && options.immediateWarm) {
        return warmAdditionalSlides(state, true);
      }
      return Promise.resolve();
    }

    var total = state.slides.length;
    var direction = shortestDirection(state.current, nextIndex, total);

    if (options && options.direction) {
      direction = options.direction > 0 ? 1 : -1;
    }

    return warmImage(state.images[nextIndex], 'high').finally(function () {
      if (reduceMotion || (options && options.immediate)) {
        jumpTo(state, nextIndex, !!(options && options.instant));
        return;
      }

      var forward = forwardDistance(state.current, nextIndex, total);
      var backward = backwardDistance(state.current, nextIndex, total);

      if (Math.min(forward, backward) > 1) {
        jumpTo(state, nextIndex, false);
        return;
      }

      animateStep(state, nextIndex, direction || 1);
    });
  }

  function bindSlider(state) {
    if (!state || state.bound) return;
    state.bound = true;

    state.slider.addEventListener(
      'pointerdown',
      function (event) {
        if (!state.active) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        prewarmNearbySlides(state);
      },
      { passive: true }
    );

    state.slider.addEventListener(
      'focusin',
      function () {
        if (!state.active) return;
        prewarmNearbySlides(state);
      },
      true
    );

    if (state.slides.length > 1) {
      state.slider.addEventListener('pointerenter', function (event) {
        if (!state.active) return;
        if (!isMousePointer(event)) return;
        state.isHovering = true;
        state.hoverRequestId = (state.hoverRequestId || 0) + 1;
        var hoverRequestId = state.hoverRequestId;
        prewarmNearbySlides(state);

        warmImage(state.images[state.hoverIndex], 'high').finally(function () {
          if (!state.isHovering) return;
          if (hoverRequestId !== state.hoverRequestId) return;
          warmAdditionalSlides(state, false);
          goTo(state, state.hoverIndex, {
            direction: 1,
            immediate: true,
            instant: true,
          });
        });
      });

      state.slider.addEventListener('pointerleave', function (event) {
        if (!state.active) return;
        if (!isMousePointer(event)) return;
        state.isHovering = false;
        state.hoverRequestId = (state.hoverRequestId || 0) + 1;
        goTo(state, 0, {
          direction: -1,
          immediate: true,
          instant: true,
        });
      });
    }

    state.slider.addEventListener('click', function (event) {
      if (!state.active) return;

      var target = event.target;

      if (!target || typeof target.closest !== 'function') return;

      var arrow = target.closest('.rynor-card-arrow');
      if (arrow) {
        event.preventDefault();
        event.stopPropagation();

        var dir = arrow.classList.contains('rynor-card-arrow--next') ? 1 : -1;
        var baseIndex =
          typeof state.pendingIndex === 'number' ? state.pendingIndex : state.current;

        state.hoverRequestId = (state.hoverRequestId || 0) + 1;
        prewarmNearbySlides(state);
        goTo(state, baseIndex + dir, {
          direction: dir,
        });
        return;
      }

      var dot = target.closest('.rynor-card-dot');
      if (dot) {
        event.preventDefault();
        event.stopPropagation();

        var index = parseInt(dot.getAttribute('data-index'), 10);
        if (isNaN(index)) {
          index = state.dots.indexOf(dot);
        }
        if (index < 0) return;

        var baseDotIndex =
          typeof state.pendingIndex === 'number' ? state.pendingIndex : state.current;
        var dirFromDots = shortestDirection(baseDotIndex, index, state.slides.length);

        state.hoverRequestId = (state.hoverRequestId || 0) + 1;
        prewarmNearbySlides(state);
        goTo(state, index, {
          direction: dirFromDots || 1,
        });
        return;
      }

      if (state.suppressClickUntil && Date.now() < state.suppressClickUntil) {
        event.preventDefault();
        event.stopPropagation();
      }
    });

    state.slider.addEventListener(
      'touchstart',
      function (event) {
        if (!state.active) return;
        if (!event.touches || !event.touches.length) return;

        finishInFlightAnimation(state);
        clearInstantSwitch(state);
        resetTouchTracking(state);

        state.touchStartX = event.touches[0].clientX;
        state.touchStartY = event.touches[0].clientY;
        state.touchLastX = state.touchStartX;
        state.touchLastTime = Date.now();
        state.touchVelocityX = 0;
        prewarmNearbySlides(state);
        warmAdjacentSlides(state);
      },
      { passive: true }
    );

    state.slider.addEventListener(
      'touchmove',
      function (event) {
        if (!state.active) return;
        if (state.touchStartX === null || state.touchStartX === undefined) return;
        if (!event.touches || !event.touches.length) return;

        var touch = event.touches[0];
        var deltaX = touch.clientX - state.touchStartX;
        var deltaY = touch.clientY - state.touchStartY;
        var absX = Math.abs(deltaX);
        var absY = Math.abs(deltaY);

        if (!state.touchLock) {
          if (absX < 6 && absY < 6) return;

          if (absX > 10 && absX >= absY * 0.9) {
            state.touchLock = 'x';
            state.hoverRequestId = (state.hoverRequestId || 0) + 1;
            state.suppressClickUntil = Date.now() + 420;
            beginTouchDrag(state);
          } else if (absY > 10 && absY > absX * 1.1) {
            state.touchLock = 'y';
            return;
          } else {
            return;
          }
        }

        if (state.touchLock !== 'x') {
          return;
        }

        if (event.cancelable) {
          event.preventDefault();
        }

        var now = Date.now();
        var elapsed = now - (state.touchLastTime || now);

        if (elapsed > 0) {
          state.touchVelocityX = (touch.clientX - (state.touchLastX || touch.clientX)) / elapsed;
        }

        state.touchLastX = touch.clientX;
        state.touchLastTime = now;
        queueTouchDrag(state, deltaX);
      },
      { passive: false }
    );

    state.slider.addEventListener(
      'touchend',
      function (event) {
        if (!state.active) return;
        if (state.touchStartX === null || state.touchStartX === undefined) return;
        if (!event.changedTouches || !event.changedTouches.length) {
          finishTouchDrag(state, true);
          return;
        }

        var touch = event.changedTouches[0];
        var deltaX = touch.clientX - state.touchStartX;
        var deltaY = touch.clientY - state.touchStartY;
        var absX = Math.abs(deltaX);
        var absY = Math.abs(deltaY);

        if (!state.touchLock && absX > 10 && absX >= absY * 0.9) {
          state.touchLock = 'x';
          state.suppressClickUntil = Date.now() + 420;
          beginTouchDrag(state);
          queueTouchDrag(state, deltaX);
        }

        if (state.touchLock === 'x' || state.touchDragging) {
          if (event.cancelable) {
            event.preventDefault();
          }
          finishTouchDrag(state, false);
          return;
        }

        resetTouchTracking(state);
      },
      { passive: false }
    );

    state.slider.addEventListener(
      'touchcancel',
      function () {
        if (!state.active) return;
        finishTouchDrag(state, true);
      },
      { passive: true }
    );
  }

  function ensureSlider(slider) {
    if (!slider || !slider.hasAttribute('data-rynor-card-slider')) return null;

    var existing = sliderState.get(slider);
    if (existing) {
      syncSliderActivation(existing);
      return existing;
    }

    var slides = toArray(slider.querySelectorAll('.rynor-card-slide'));
    if (!slides.length) return null;

    var state = {
      slider: slider,
      card: getCardRoot(slider),
      desktopOnly: isDesktopOnlySlider(slider),
      slides: slides,
      images: slides.map(function (slide) {
        return slide.querySelector('img');
      }),
      dots: toArray(slider.querySelectorAll('.rynor-card-dot')),
      viewport: null,
      track: null,
      current: 0,
      hoverIndex: slides.length > 1 ? 1 : 0,
      touchStartX: null,
      touchStartY: null,
      touchLastX: null,
      touchLastTime: 0,
      touchVelocityX: 0,
      touchLock: null,
      touchDragging: false,
      dragBaseVisualIndex: null,
      dragCurrentOffset: 0,
      dragQueuedOffset: 0,
      dragFrame: null,
      suppressClickUntil: 0,
      cleanupTimer: null,
      finishAnimation: null,
      isAnimating: false,
      prewarmed: false,
      bound: false,
      pendingIndex: null,
      instantResetTimer: null,
      isHovering: false,
      prependedClones: 0,
      hoverRequestId: 0,
      active: false,
      dotIndex: 0,
      dotsInitialized: false,
    };

    if (slider.dataset.hoverIndex) {
      var hoverIndex = parseInt(slider.dataset.hoverIndex, 10);
      if (!isNaN(hoverIndex)) {
        state.hoverIndex = clampIndex(hoverIndex, slides.length);
      }
    }

    sliderState.set(slider, state);

    state.images.forEach(function (img, index) {
      if (!img) return;
      setImageHints(
        img,
        index === 0 ? img.getAttribute('loading') || 'lazy' : 'lazy',
        index === 0 ? img.getAttribute('fetchpriority') || 'auto' : 'low'
      );
    });

    syncSliderActivation(state);
    return state;
  }

  function init(root) {
    toArray((root || document).querySelectorAll(enhancedSliderSelector)).forEach(
      function (slider) {
        ensureSlider(slider);
      }
    );
  }

  function maybeInitNode(node) {
    if (!node || node.nodeType !== 1) return;

    if (node.matches && node.matches(enhancedSliderSelector)) {
      ensureSlider(node);
    }

    if (typeof node.querySelectorAll === 'function') {
      toArray(node.querySelectorAll(enhancedSliderSelector)).forEach(function (slider) {
        ensureSlider(slider);
      });
    }
  }

  function watchDom() {
    if (domObserver || !('MutationObserver' in window)) return;

    domObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        toArray(mutation.addedNodes).forEach(function (node) {
          maybeInitNode(node);
        });
      });
    });

    domObserver.observe(document.documentElement || document.body, {
      childList: true,
      subtree: true,
    });
  }

  function refreshAllSliderLayouts() {
    if (resizeQueued) return;
    resizeQueued = true;

    raf(function () {
      resizeQueued = false;
      toArray(document.querySelectorAll(enhancedSliderSelector)).forEach(function (slider) {
        var state = ensureSlider(slider);
        if (!state || !state.active) return;
        finishInFlightAnimation(state);
        settleToCurrent(state);
        primeAboveFold(state);
      });
    });
  }

  var api = {
    __version: '3.3.0',
    init: function (root) {
      init(root || document);
    },
    prewarm: function (root) {
      toArray((root || document).querySelectorAll(enhancedSliderSelector)).forEach(
        function (slider) {
          var state = ensureSlider(slider);
          if (state && state.active) {
            prewarmNearbySlides(state);
          }
        }
      );
    },
    goTo: function (slider, index, options) {
      var state = ensureSlider(slider);
      if (!state) return Promise.resolve();
      return goTo(state, index, options || {});
    },
    refresh: function (root) {
      toArray((root || document).querySelectorAll(enhancedSliderSelector)).forEach(
        function (slider) {
          var state = ensureSlider(slider);
          if (state && state.active) {
            finishInFlightAnimation(state);
            settleToCurrent(state);
          }
        }
      );
    },
  };

  window.RynorCardSlider = api;

  function boot() {
    init(document);
    watchDom();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', refreshAllSliderLayouts, { passive: true });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('rynor:collection-grid-updated', function (event) {
    var root = event && event.detail && event.detail.root ? event.detail.root : document;
    init(root);
    api.prewarm(root);
  });
})();
(function () {
  const ADD_URL = "/cart/add.js";

  function getCard(el) {
    return el.closest("article[data-card]") || el.closest("article.product-loop__item");
  }

  function openOverlay(card) {
    const overlay = card && card.querySelector("[data-size-overlay]");
    if (!overlay) return;
    overlay.classList.add("is-open");
    overlay.setAttribute("aria-hidden", "false");
  }

  function closeOverlay(card) {
    const overlay = card && card.querySelector("[data-size-overlay]");
    if (!overlay) return;
    overlay.classList.remove("is-open");
    overlay.setAttribute("aria-hidden", "true");
  }

  async function addVariant(variantId, qty = 1) {
    const res = await fetch(ADD_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: Number(variantId), quantity: qty })
    });

    if (!res.ok) throw new Error(await res.text().catch(() => "Add failed"));

    document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    document.dispatchEvent(new CustomEvent("ajaxCart:refresh", { bubbles: true }));

    document.dispatchEvent(new CustomEvent("cart:open", { bubbles: true }));
    document.dispatchEvent(new CustomEvent("ajaxCart:open", { bubbles: true }));

    const openers = [
      '[data-ajax-cart-toggle]',
      '[data-cart-toggle]',
      '.js-ajax-cart-open',
      '.js-slideout-open',
      '[aria-controls="slideout-ajax-cart"]'
    ];
    for (const sel of openers) {
      const el = document.querySelector(sel);
      if (el) { el.click(); break; }
    }

    return res.json();
  }

  // Bag click: if single available -> add, else open overlay.
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-open-size-overlay][data-quick-add]");
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const card = getCard(btn);
    if (!card) return;

    const single = btn.getAttribute("data-single-variant");
    if (single) {
      try {
        btn.disabled = true;
        await addVariant(single, 1);
      } catch (err) {
        console.warn(err);
      } finally {
        btn.disabled = false;
      }
      return;
    }

    openOverlay(card);
  });

  // Size click -> add that variant
  document.addEventListener("click", async (e) => {
    const sizeBtn = e.target.closest(".cc-sizeOverlay__btn[data-variant-id]");
    if (!sizeBtn) return;

    e.preventDefault();
    e.stopPropagation();
    if (sizeBtn.disabled) return;

    const card = getCard(sizeBtn);
    const variantId = sizeBtn.getAttribute("data-variant-id");
    if (!card || !variantId) return;

    try {
      sizeBtn.disabled = true;
      await addVariant(variantId, 1);
      closeOverlay(card);
    } catch (err) {
      console.warn(err);
    } finally {
      sizeBtn.disabled = false;
    }
  });

  // Close overlay if you click outside the size bar
  document.addEventListener("click", (e) => {
    if (e.target.closest(".cc-sizeOverlay__inner")) return;

    document.querySelectorAll(".cc-sizeOverlay.is-open").forEach((overlay) => {
      const card = getCard(overlay);
      if (card) closeOverlay(card);
    });
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    document.querySelectorAll(".cc-sizeOverlay.is-open").forEach((overlay) => {
      const card = getCard(overlay);
      if (card) closeOverlay(card);
    });
  });
})();
